import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import DropDownModal from "../../Patients/DropDownModal.vue";
import ResourceComponentPopup from "../../VeinsTracker/ResourceComponentPopup.vue";
import CollectPayments from "../../../Payments/CollectPayments.vue";
import PatientComponent from "../../../components/PatientComponent.vue";

import PatientTasksTable from "../../../components/TaskTable.vue"; //hmm check
import AuditLogComponent from "../../../components/AuditLogComponent.vue";

import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";

export default {
  name: "StageDisplay",
  components: {
    //QuillEditor,
    DropDownModal,
    AuditLogComponent,
    CollectPayments,
    ResourceComponentPopup,
    PatientTasksTable,
    PatientComponent,
    // MergePatients,
  },
  data() {
    return {
      showPatientTasksTable: false,
      taskVisitId: 0,
      taskPatientId: 0,
      timeZoneId: 0,
      showProfilePopupVar: false,
      displaySearch: false,
      showPagesMin: 1,
      showPagesMax: 5,
      taskTable: false,
      patTasks: [],

      //SignalR
      MyUserId: 0,
      connection: {},
      startedPromise: {},

      //refund
      firstTime: true,
      refundAmount: "",
      //receipt
      SendReceiptRequest: {
        PatientId: 0,
        VisitId: 0,
        LocalDateTime: new Date(),
        BillNo: 0,
        PNDX: 0,
        Email: "",
        Phone: "",
        DC: "",
      },
      //reminder
      Reminder: [],
      btnProColl: false,
      //pay
      displayPayMethod: false,
      //-- Modals display
      cardModal: false,
      cashModal: false,
      chequeModal: false,
      ActivePaymentRequest: {},
      limitAmount: 0,

      //Page
      showPagesMin1: 1,
      showPagesMax1: 5,
      showPagesMin11: 1,
      showPagesMax11: 5,

      InviteType: ["SMS", "Email"],
      baseConvert: {},

      emailHide: "",
      phoneHide: "",

      displayRem1: false,
      displayRem2: false,
      displayRem: false,

      Email11: "",
      Phone11: "",
      selectInfo: "",
      //usmanbutt
      VhpageNumber: 1,
      VhpageSize: 50,
      VhtotalRows: 0,
      VhtotalPages: 0,

      //zahid
      PhpageNumber: 1,
      PhpageSize: 50,
      PhtotalRows: 0,
      PhtotalPages: 0,
      urlVal: "",
      //Data table MergeSugg
      pageNumberSuggest: 1,
      pageSizeSuggest: 50,
      totalPagesSuggest: 0,
      totalRowsSuggest: 0,

      //Data table MergeSugg
      pageNumberSuggest1: 1,
      pageSizeSuggest1: 50,
      totalPagesSuggest1: 0,
      totalRowsSuggest1: 0,

      practName: "",

      emailHisUser: "",
      textHistorySerch: [],
      Ownername: "",
      //Editor
      setReadonly: false,
      // email Editor
      Eeditor: false,
      Esubj: false,
      Eemail: false,
      Ename: false,
      // sms Editor
      Enumber: false,
      Esubj1: false,
      Ename1: false,
      loadObj: {},
      //email Info
      chatSms: "",
      activeVisitReasons: [],
      emailTo: "",
      subject: "",
      allFilterVisitHist: "",
      emailMessage: "",
      practiceID: "",
      //Date varibles
      val1: "",
      val2: "",
      val3: "",
      phone: "",
      email: "",
      ssn: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      externalId: "",
      primaryInsurance: "",
      primaryInsuranceNo: "",
      primaryInsuranceId: "",
      primaryInsuranceGroupId: "",
      secondInsurance: "",
      secondInsuranceNo: "",
      secondInsuranceId: "",
      secondInsuranceGroupId: "",
      EmployeeRolesStr: [],
      updButton: 1,
      delButton: 1,
      //loader
      loader: "",
      //Timer
      intervalTime: 15000,
      TimerObject: {},
      RefreashObj: {},
      PvisitId: "",
      startDate: "",
      endDate: "",
      startDate_1: "",
      endDate_1: "",
      initDate: "",
      initDate_1: "",
      startDate_2: "",
      endDate_2: "",
      initDate_2: "",
      startDate_3: "",
      endDate_3: "",
      initDate_3: "",
      TextSearch: "",
      filterTextSearch: [],
      allFilterPatients_1: [],
      paymentStatus: [
        { text: "Sent", PValue: 1 },
        { text: "Pending", PValue: 2 },
        { text: "Disputed", PValue: 3 },
        { text: "Paid", PValue: 4 },
        { text: "Refund", PValue: 5 },
        { text: "Deleted", PValue: 6 },
      ],
      visitReasons: [],
      visitTypes: [],
      textHistory: [],
      visitHistory: [],
      allPatients: [],
      allInsurances: [],
      suggestedPatients: [],
      suggestedPatients1: [],

      allRawPatients: [],
      allFilterPatients: [],
      stagesSteps: [],
      emailHistory: [],
      allFilterPayHist: [],
      visitQuests: [],
      visitDemo: [],
      phyList: [],
      users: [],
      smsTempsList: [],
      selectedSmsId: 0,
      aSingleSms: {
        name: "",
        smsText: "",
      },
      aSingleUserSmsHist: [],
      auditData: [],
      emailTempsList: [],
      aSingleEmail: {
        name: "",
        emailText: "",
        emailSubject: "",
      },
      aSingleText: {
        userId: "",
      },
      filterPatList: [],
      filterNameF: "",
      filterNameL: "",

      filterFirstName: "",
      filterLastName: "",
      filterPhone: "",
      filterDate: "",
      filterDDate: "",
      //-- Actives
      aSinglePatient: {
        practiceId: "",
        stats: {
          visits: 0,
          payments: 0,
          texts: 0,
          emails: 0,
        },
        insurance: {
          primaryInsurance: "",
          primaryInsuranceId: "",
          primaryInsuranceNo: "",
          primaryInsuranceGroupId: "",
          secondaryInsurance: "",
          secondaryInsuranceId: "",
          secondaryInsuranceNo: "",
          secondaryInsuranceGroupId: "",
        },
      },
      paymentHistory: [],
      requestPaymentsList: [],
      aSinglePaymentReceived: {
        pndx: 0,
        patientId: 0,
        practiceId: 0,
        visitId: 0,
        billNo: 0,
        collectedBy: 0,
        paymentDate: new Date(),
        amount: 0,
        paymentMethod: "",
        holderName: "",
        tdNumber: "",
        cardCVC: "",
        comment: "",
        zip: "",
      },
      aSingleRequestPayment: {
        amount: 0,
        email: "",
        phone: "",
        comment: "",
      },
      paymentReminder: {
        visitId: 0,
        email: "",
        phone: "",
        actionDate: new Date(),
      },
      aSelectedPatient: "",
      aSelectedInsurance: "",
      aSingleStage: "",
      activeStageNdx: -1,
      MyActiveStageNdx: 0,
      activeStep: -1,
      //-- Search
      mainSearch: {
        searchVeinsId: "",
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
        searchDate: null,
      },

      //-- Search
      suggested: {
        searchVeinsId: "",
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
        Dob: "",
        searchDate: null,
      },

      //-- Search
      suggested1: {
        searchVeinsId: "",
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
        Dob: "",
        searchDate: null,
      },

      // ***Sort Main Table
      mainSort: {
        name: 0,
        dos: 0,
        visitType: 0,
        timein: 0,
      },

      //-- Resources
      stageRes: [],
      stepRes: [],
      patResSumm: [],
      showResourceComponentDialog: false,

      //-- misc
      baseStagesSteps: "",
      operators: [],
      commentText: "",
      commentsList: [],
      showDropDownModal: false,
      p_visitId: Number,
      button_Name: String,

      isDelStepPressed: false,
      trackerStageStepStatus: ["inactive", "active", "complete", "skip"],
      // for merge
      VisitPayCounts: [],
      aSelectedCounts: [],
      mergedPat: {
        firstName: "",
        lastName: "",
        dob: "",
        gender: "",
        phone: "",
        email: "",
        ssn: "",
        address: "",
        streetAddress: "",
        externalId: "",
        city: "",
        state: "",
        zip: "",
        primaryIns: "",
        primaryInsNo: "",
        primaryInsId: "",
        primaryInsGroupId: "",
        secondIns: "",
        secondInsNo: "",
        secondInsId: "",
        secondInsGroupId: "",
        // will display table steps
      },
      stepsInStagesForTable: [],
      patientSteps: [],
      Image: "",
      showMerge: false,
      showCapturedData: [],
      //-- pagination
      totalRecords: 0,
      pagerows: 10,
      pageSize: 50,
      pageNumber: 1,
      stageId: 0,

      //payment
      pageNumberPays: 1,
      pageSizePays: 50,
      totalPagesPays: 0,
      totalRowsPays: 0,

      filteredPaymentRequests: "",

      //-- Filter
      showLoader: false,
      filter: {
        veinsId: "",
        externalId: "",
        firstName: "",
        lastName: "",
        phone: "",
        startDate: "",
        endDate: "",
      },

      sortColumnSuggest1: 0,
      sortColumnOptionSuggest1: 0,
      sortColumnSuggest: 0,
      sortColumnOptionSuggest: 0,

      //-- Date Menu for date search
      currentDateRange: "",
      mainSearchDate: null,
      dateMenu: [
        {
          label: "Today",
          command: () => {
            this.setDateToday();
          },
        },
        {
          label: "Yesterday",
          command: () => {
            this.setDateLastXDays(1);
          },
        },
        {
          label: "Last 7 Days",
          command: () => {
            this.setDateLastXDays(7);
          },
        },
        {
          label: "Last 30 Days",
          command: () => {
            this.setDateLastXDays(30);
          },
        },
        {
          label: "This Month",
          command: () => {
            this.setDateThisMonth();
          },
        },
        {
          label: "Last Month",
          command: () => {
            this.setDateLastMonth();
          },
        },
        {
          label: "Uptil Now",
          command: () => {
            this.setDateUptilNow();
          },
        },
      ],
      groupIdAndColorArray: [],
      groupModel: false,
      firstSelectedGroupId: "",
      secondSelectedGroupId: "",
      firstSelectedGroupIdPNDX: "",
      secondSelectedGroupIdPNDX: "",
      firstSelectedGID: "",
      secondSelectedGID: "",
      firstSelectGroupColor: "",
      secondSelectGroupColor: "",
      groupingLoader: 0,
      groupingFirstPatientId: 0,
      groupingSecondPatientId: 0,
      groupingVisitId: 0,
    };
  }, // data
  computed: {
    computedGroupingStyle() {
      return (groupColor, isGroup) => {
        return {
          backgroundColor: isGroup ? groupColor : "",
          width: "25px",
          marginRight: "10px",
          border: `${isGroup ? "" : "1px dotted black"}`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color:
            this.isColorDarkOrLight(groupColor) === "dark" ? "white" : "black",
          fontWeight: 500,
        };
      };
    },
    computedGroupingLoader() {
      return (groupColor, isGroup) => {
        return {
          border: "4px solid rgba(0, 0, 0, 0.1)",
          borderTop: `${
            isGroup
              ? `4px solid ${
                  this.isColorDarkOrLight(groupColor) === "dark"
                    ? "white"
                    : "black"
                }`
              : `4px solid black`
          }`,
          borderRadius: "50%",
          width: "24px",
          height: "24px",
          animation: "loader 1s linear infinite",
          margin: "0 auto",
        };
      };
    },
  },
  emits: {
    click: null,
    CallFetchDataPatients() {
      this.connection
        .invoke("FetchDataAll", this.MyUserId)
        .catch(console.error);
      return true;
    },
  },
  // ~~methods
  methods: {
    isColorDarkOrLight(color) {
      // Check if color is null
      if (!color) {
        return "unknown"; // Or any other default value you prefer
      }
      // Convert color code to RGB components
      const r = parseInt(color.substr(1, 2), 16);
      const g = parseInt(color.substr(3, 2), 16);
      const b = parseInt(color.substr(5, 2), 16);

      // Calculate relative luminance
      const relativeLuminance =
        (0.2126 * r) / 255 + (0.7152 * g) / 255 + (0.0722 * b) / 255;

      // Compare relative luminance to threshold
      return relativeLuminance < 0.5 ? "dark" : "light";
    },
    isFirstGroupSelected() {
      return (
        this.firstSelectedGroupId !== "" &&
        this.firstSelectGroupColor !== "" &&
        (this.firstSelectedGroupIdPNDX !== "" ||
          this.firstSelectedGroupIdPNDX !== 0)
      );
    },
    handleClick(groupId, groupColor, pndx, isGroup, patientId, gid, visitId) {
      if (this.isFirstGroupSelected()) {
        this.handleSecondGroupId(
          groupId,
          groupColor,
          pndx,
          patientId,
          gid,
          visitId
        );
      } else if (isGroup) {
        this.handleSecondGroupId(
          groupId,
          groupColor,
          pndx,
          patientId,
          gid,
          visitId
        );
      } else {
        this.handleFirstGroupId(
          groupId,
          groupColor,
          pndx,
          patientId,
          gid,
          visitId
        );
      }
    },
    handleFirstGroupId(groupId, groupColor, pndx, patientId, gid, visitId) {
      this.groupingLoader = pndx;
      this.firstSelectedGroupId = groupId;
      this.firstSelectedGID = gid;
      this.firstSelectGroupColor = groupColor;
      this.firstSelectedGroupIdPNDX = pndx;
      this.groupingFirstPatientId = patientId;
      this.groupingVisitId = visitId;
      createToast("Ready to assign to new group", {
        type: "info",
        transition: "slide",
        timeout: 2500,
      });
    },
    handleSecondGroupId(groupId, groupColor, pndx, patientId, gid, visitId) {
      this.secondSelectedGroupId = groupId;
      this.secondSelectedGID = gid;
      this.secondSelectGroupColor = groupColor;
      this.secondSelectedGroupIdPNDX = pndx;
      this.groupingSecondPatientId = patientId;

      if (
        this.firstSelectedGroupId !== "" &&
        this.secondSelectedGroupId !== ""
      ) {
        this.AddToOtherPatientGroup();
        createToast("Assigned to new group", {
          type: "success",
          transition: "slide",
          timeout: 2500,
        });
      } else if (
        this.firstSelectedGroupId === "" &&
        this.secondSelectedGroupId !== ""
      ) {
        this.groupModel = true;
        this.groupingVisitId = visitId;
      }
    },
    modifyToOtherPatientGroup() {
      this.groupingLoader = this.secondSelectedGroupIdPNDX;
      this.firstSelectedGroupId = this.secondSelectedGroupId;
      this.firstSelectedGID = this.secondSelectedGID;
      this.firstSelectGroupColor = this.secondSelectGroupColor;
      this.firstSelectedGroupIdPNDX = this.secondSelectedGroupIdPNDX;
      this.groupingFirstPatientId = this.groupingSecondPatientId;

      this.secondSelectedGroupId = "";
      this.secondSelectedGID = "";
      this.secondSelectGroupColor = "";
      this.secondSelectedGroupIdPNDX = 0;
      this.groupingSecondPatientId = 0;

      this.groupModel = false;
      createToast("Ready to assign to new group", {
        type: "info",
        transition: "slide",
        timeout: 2500,
      });
    },
    removeFromPatientGroup() {
      this.groupingLoader = this.secondSelectedGroupIdPNDX;
      this.secondSelectedGroupId = new Date().getTime().toString();
      this.secondSelectGroupColor = "";
      this.firstSelectedGroupIdPNDX = this.secondSelectedGroupIdPNDX;
      this.firstSelectedGID = this.secondSelectedGID;
      this.secondSelectedGID = "";
      this.secondSelectedGroupIdPNDX = 0;
      this.groupingFirstPatientId = this.groupingSecondPatientId;
      this.groupingSecondPatientId = 0;
      this.AddToOtherPatientGroup();
      this.groupModel = false;
      createToast("Removed from group", {
        type: "success",
        transition: "slide",
        timeout: 2500,
      });
    },
    async AddToOtherPatientGroup() {
      this.intDummyComm();
      this.dummyComm.VisitId = this.groupingVisitId;

      const obj = {
        DC: this.dummyComm,
        FromPNDX: this.firstSelectedGroupIdPNDX,
        ToPNDX: this.secondSelectedGroupIdPNDX,
        FromGroupId: this.firstSelectedGroupId,
        ToGroupId: this.secondSelectedGroupId,
        FromGID: this.firstSelectedGID,
        ToGID: this.secondSelectedGID,
        FromGroupColor: this.firstSelectGroupColor,
        ToGroupColor: this.secondSelectGroupColor,
        ToPatientId: this.groupingSecondPatientId,
        FromPatientId: this.groupingFirstPatientId,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Trackers/AddToOtherPatientGroup",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          if (res.data.status === true || res.data.status === false) {
            this.firstSelectedGroupId = "";
            this.secondSelectedGroupId = "";
            this.firstSelectedGID = "";
            this.secondSelectedGID = "";
            this.firstSelectedGroupIdPNDX = "";
            this.secondSelectedGroupIdPNDX = "";
            this.firstSelectGroupColor = "";
            this.secondSelectGroupColor = "";
            this.loadInitWithoutLoad();
            this.groupModel = false;
            this.groupingFirstPatientId = 0;
            this.groupingSecondPatientId = 0;
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
        });
    },
    async UpdateAppointmentTime(data) {
      this.intDummyComm();

      const obj = {
        DC: this.dummyComm,
        PNDX: data.pndx,
        VisitId: data.visitId,
        PatientId: data.patientId,
        AppointmentTime: data.appointmentTime,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Trackers/UpdateAppointmentTime",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          this.loadInit();
        })
        .finally(() => {
          this.ResetLogoutTime();
        });
    },
    callAuditLogPatientId() {
      this.$refs.auditLogComponent.loadInitPatient(
        this.aSinglePatient.patientId
      );
    },
    //Reconcile
    showReconcileModel(pay) {
      Swal.fire({
        title: "Are you sure?",
        text:
          "You want to Reconcile this Payment. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.value) {
          this.intDummyComm();
          this.dummyComm.extras = pay.status;
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;
          this.dummyComm.extras2 = pay.billNo;
          this.dummyComm.filter = "";

          const myData = {
            dc: this.dummyComm,
            filter: this.$store.state.filterSTGDSP,
            sortColumn: 0,
            sortColumnOption: 0,
          };

          const url = this.SERVER + "/VNSPRAAPI/Trackers/ReconcilePaymentById";
          this.axiosGetData(url, myData, 900);
        }
      });
    },
    //refund
    showSubmitRefundModal(pay) {
      this.ActivePaymentRequest = pay;
      this.refundMethodType = pay.paymentMethod;
      $("#displayReceipt11").modal("show");
    },
    refundPayment() {
      this.intDummyComm();
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      const url = this.SERVER + "/VNSPRAAPI/Payments/RefundPayment";
      const myData = {
        DC: this.dummyComm,
        BillNo: this.ActivePaymentRequest.billNo,
        DateLocalTime: new Date(),
        RefundMethod: this.refundMethodType,
        Amount: this.refundAmount,
      };
      this.axiosGetData(url, myData, 9003);
    },
    amountRefundCheck(evt, val) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        //Beautiful
        val = val + String.fromCharCode(evt.keyCode);
        if (
          parseFloat(val) >
          this.ActivePaymentRequest.amount -
            this.ActivePaymentRequest.refundAmount
        ) {
          evt.preventDefault();
          return;
        }
        return true;
      }
    },
    //receipt
    sendReceipt(pay) {
      $("#displayReceipt").modal("show");
      this.SendReceiptRequest.PatientId = pay.patientId;
      this.SendReceiptRequest.PracticeId = pay.pacticeId;
      this.SendReceiptRequest.Email = pay.email;
      this.SendReceiptRequest.Phone = pay.phone;
      this.SendReceiptRequest.BillNo = pay.billNo;
      this.SendReceiptRequest.VisitId = pay.visitId;
      this.SendReceiptRequest.LocalDateTime = new Date();
      this.SendReceiptRequest.PNDX = pay.pndx;
    },
    closeModalSms() {
      this.displayRem1 = false;
    },
    closeModalEmail() {
      this.displayRem2 = false;
    },
    onSelectInfo() {
      this.phoneHide = "";
      this.emailHide = "";
      this.displayRem2 = true;
    },
    onSelectInfo1() {
      if (this.selectInfo == "SMS") {
        this.phoneHide = true;
        this.emailHide = "";
      } else if (this.selectInfo == "Email") {
        this.emailHide = true;
        this.phoneHide = "";
      }
    },
    sendClick() {
      this.intDummyComm();
      let stringselect = "";
      if (this.selectInfo == "SMS") {
        stringselect = this.selectInfo;
      } else if (this.selectInfo == "Email") {
        stringselect = this.selectInfo;
      }

      //url setting
      const str = localStorage.OSversion;
      const arr = str.split("<VEINS2021/>");
      this.baseConvert[0] = btoa(localStorage.xeon);
      this.baseConvert[1] = btoa(arr[1]);

      const url1 =
        this.CHECKINSERVER +
        "?cra=" +
        this.baseConvert[0] +
        "%26&resu=" +
        this.baseConvert[1];

      const Invite = {
        url: url1,
        stringSelect: stringselect,
        Email: this.Email11,
        Phone: this.Phone11,
        locationName: this.practName,
        dc: this.dummyComm,
      };

      const url = this.SERVER + "/VNSPRAAPI/Patient/SendCheckInUrl";
      this.axiosGetData(url, Invite, 2002);
    },
    //payment Request
    getPaymentResTabl() {
      this.intDummyComm();
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/GetActivePaymentRequestsListyId";
      const myData = this.dummyComm;
      this.$refs.cp.getPaymentResTable(
        this.aSinglePatient.visitId,
        this.aSinglePatient.patientId
      );
      //this.axiosGetData(url, myData, 8000);
    },
    colorStyle(status) {
      if (status == 1) {
        //Requested
        return "background-color:#03a9f3 ;border-color:#03a9f3";
      } else if (status == 2) {
        //Pending
        return "background-color:#03a9f3 ;border-color:#03a9f3";
      } else if (status == 3) {
        //Disputed
        return "background-color:black; border-color:black";
      } else if (status == 4) {
        //Paid
        return "background-color:#00C292; border-color:#00C292";
      } else if (status == 5) {
        //ReFund
        return "background-color:#dc3f4e; border-color:#dc3f4e";
      } else if (status == 6) {
        //PartiallyRefunded
        return "background-color:#DFCE1D; border-color:#DFCE1D";
      } else if (status == 7) {
        //PartiallyPaid
        return "background-color:#03a9f3; border-color:#03a9f3";
      } else if (status == 7) {
        //Deleted
        return "background-color:#03a9f3; border-color:#03a9f3";
      } else if (status == 9) {
        //Reconciled
        return "background-color:#d19e01; border-color:#d19e01";
      }
    },
    showSubmitPaymentModal(methodType) {
      this.displayPayMethod = false;
      if (methodType == 1) {
        $("#debit").modal("show");
      } else if (methodType == 2) {
        $("#cash").modal("show");
      } else if (methodType == 3) {
        $("#cheque").modal("show");
      }
    },
    showReminderModel(pay) {
      $("#reminder").modal("show");
      this.Reminder = pay;
    },
    closeModalRem() {
      this.displayPayMethod = false;
    },
    //search
    applyDateClickSuggested() {
      const str = this.suggested.Dob;
      const arr = str.split("-");
      let three = arr[0].slice(0, 3);
      let two = arr[0].slice(0, 2);
      let one = arr[0].slice(0, 1);
      if (three === "000" || two === "00" || one === "0") {
        return;
      }

      this.pageNumberSuggest = 1;
      if (
        this.suggested.searchVeinsId == "" &&
        this.suggested.searchExternalId == "" &&
        this.suggested.searchFirstName == "" &&
        this.suggested.searchLastName == "" &&
        this.suggested.searchPhone == "" &&
        this.suggested.Dob == ""
      ) {
        this.mergeModalClickReloadChange();
      } else {
        this.mergeModalClick1();
      }
    },
    applyDateClickSuggested1() {
      const str = this.suggested1.Dob;
      const arr = str.split("-");
      let three = arr[0].slice(0, 3);
      let two = arr[0].slice(0, 2);
      let one = arr[0].slice(0, 1);
      if (three === "000" || two === "00" || one === "0") {
        return;
      }

      this.pageNumberSuggest1 = 1;
      this.mergeModalClickReload1();
    },
    orderBySuggested(column) {
      if (this.sortColumnSuggest == column) {
        switch (this.sortColumnOptionSuggest) {
          case 0:
            this.sortColumnOptionSuggest = 1;
            break;
          case 1:
            this.sortColumnOptionSuggest = 2;
            break;
          case 2:
            this.sortColumnSuggest = 0;
            this.sortColumnOptionSuggest = 0;
            break;
        }
      } else {
        this.sortColumnSuggest = column;
        this.sortColumnOptionSuggest = 1;
      }
      this.pageNumberSuggest = 1;
      this.mergeModalClick();
    },
    orderBySuggested1(column) {
      if (this.sortColumnSuggest1 == column) {
        switch (this.sortColumnOptionSuggest1) {
          case 0:
            this.sortColumnOptionSuggest1 = 1;
            break;
          case 1:
            this.sortColumnOptionSuggest1 = 2;
            break;
          case 2:
            this.sortColumnSuggest1 = 0;
            this.sortColumnOptionSuggest1 = 0;
            break;
        }
      } else {
        this.sortColumnSuggest1 = column;
        this.sortColumnOptionSuggest1 = 1;
      }
      this.pageNumberSuggest = 1;
      this.mergeModalClickReload1();
    },
    //search
    applyDateClick() {
      this.pageNumber = 1;
      this.applyFilterAPI(this.stageid, 1, true);
    },
    getStageTimeinTime(val) {
      if (!val) return;
      const dd = new Date(val);
      return dd.toLocaleTimeString();
    },

    getStageTimeinDate(val) {
      if (!val) return;
      const dd = new Date(val);
      return dd.toLocaleDateString();
    },

    applyFilterAPI(stageid = 0, what = 1, loading = false) {
      //+++555+++/
      const darr = this.currentDateRange.split(" to ");
      let startDate = "";
      let endDate = "";

      if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
      else startDate = new Date(darr[0]);
      endDate = new Date(darr[1]);

      const filter = {
        veinsId: this.mainSearch.searchVeinsId,
        externalId: this.mainSearch.searchExternalId,
        firstName: this.mainSearch.searchFirstName,
        lastName: this.mainSearch.searchLastName,
        phone: this.mainSearch.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        stageId: this.stageId,
      };

      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.filter = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.stageId = this.stageId;
      this.dummyComm.StageId = this.stageId;
      this.dummyComm.filter = "";

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sort: this.mainSort,
      };

      //alert(what);
      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/GetStageDisplayFilteredPatients"; //myfunction

      //;
      if (loading) {
        try {
          this.loader = this.$loading.show({
            color: "#03a9f3",
          });
          this.axiosGetData(url, myData, what);
          this.loader.hide();
        } catch {
          this.loader.hide();
        } finally {
          this.loader.hide();
        }
        this.loader.hide();
      } else this.axiosGetData(url, myData, what);
    }, // applyFilterAPI()

    async textHistoryClick() {
      this.aSingleText = {
        userId: "",
      };
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetTextHistoryByVisitId";
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.textHistory = await this.mixinsAxiosGetData(url, this.dummyComm);
      //;
      for (let j = 0; j < this.textHistory.length; j++) {
        this.textHistory[j].message = this.removeHTML(
          this.textHistory[j].message
        );
      }

      //this.clickSmsLis()
    },

    applySearchClick() {
      this.pageNumber = 1;
      this.applyFilterAPI(this.stageId, 1, true);
      //this.loadInit();
      //this.searchMainList();
    },
    setDateUptilNow() {
      const date = new Date();
      let str = "";
      const options = { year: "numeric", month: "short", day: "numeric" };
      this.currentDateRange =
        "From start to " + date.toLocaleDateString(undefined, options);
    },

    setDateLastMonth() {
      const date = new Date();
      const prevMonthLastDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        0
      );
      var prevMonthFirstDate = new Date(
        date.getFullYear() - (date.getMonth() > 0 ? 0 : 1),
        (date.getMonth() - 1 + 12) % 12,
        1
      );
      let str = "";
      const options = { year: "numeric", month: "short", day: "numeric" };
      this.currentDateRange =
        prevMonthFirstDate.toLocaleDateString(undefined, options) +
        " to " +
        prevMonthLastDate.toLocaleDateString(undefined, options);
    },

    setDateThisMonth() {
      const date = new Date();
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let str = "";
      const options = { year: "numeric", month: "short", day: "numeric" };
      this.currentDateRange =
        firstDay.toLocaleDateString(undefined, options) +
        " to " +
        date.toLocaleDateString(undefined, options);
    },

    setDateLastXDays(days) {
      let startdate = new Date(new Date().setDate(new Date().getDate() - days));
      let enddate = new Date();
      if (days == 1) enddate = startdate;

      const options = { year: "numeric", month: "short", day: "numeric" };
      this.currentDateRange =
        startdate.toLocaleDateString(undefined, options) +
        " to " +
        enddate.toLocaleDateString(undefined, options);
    },

    setDateToday() {
      let str = "";
      let today = new Date();
      const options = { year: "numeric", month: "short", day: "numeric" };
      str = today.toLocaleDateString(undefined, options);
      this.currentDateRange = str + " to " + str;
    },

    toggle(event) {
      this.$refs.op.toggle(event);
    },
    calculateSpan() {
      document.getElementsByClassName("getSpanList").forEach((e) => {
        var isexist = false;
        e.children.forEach((t) => {
          if (t.nodeName == "BR") {
            isexist = true;
          }
        });
        if (e.children.length > 1 && !isexist) {
          e.insertBefore(document.createElement("br"), e.childNodes[8]);
        }
      });
      return false;
    },
    showMergeSwal() {
      Swal.fire({
        title: "Are you sure?",
        text:
          "This Patient already has a visit for this Date of Service. Do you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.value) {
          this.alertModalClick_Suggested();
        }
      });
    },
    //filter DataTable
    SearchDataTable() {
      this.pageNumber = 1;
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.extras1 = "";
      //this.dummyComm.pageNumber = this.pageNumber;
      //this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.Filter = this.filterNameF;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/StageDispInitData";
      this.axiosGetData(url, this.dummyComm, 1);
    },

    //code for Data Tables Merge
    pageChangeSuggested1(obj) {
      if (obj == "Next") {
        if (this.pageNumberSuggest1 < this.totalPagesSuggest1) {
          this.pageNumberSuggest1 += 1;
        }
      } else if (obj == "Previous" && this.pageNumberSuggest1 != 1) {
        this.pageNumberSuggest1 -= 1;
      } else {
        this.pageNumberSuggest1 = obj;
      }

      if (this.showPagesMax1 / 2 < this.pageNumberSuggest1) {
        this.showPagesMin1 = this.pageNumberSuggest1 - 4;
        this.showPagesMax1 = this.pageNumberSuggest1 + 4;
      } else if (this.showPagesMin1 / 2 < this.pageNumberSuggest1) {
        this.showPagesMin1 = this.pageNumberSuggest1 - 4;
        this.showPagesMax1 = this.pageNumberSuggest1 + 4;
        if (this.showPagesMax1 < 5) {
          this.showPagesMax1 = 5;
        }
      } else {
        this.showPagesMin1 = 1;
        this.showPagesMax1 = 5;
      }

      this.mergeModalClickReload1();
    },
    pageChangeSuggested(obj) {
      if (obj == "Next") {
        if (this.pageNumberSuggest < this.totalPagesSuggest) {
          this.pageNumberSuggest += 1;
        }
      } else if (obj == "Previous" && this.pageNumberSuggest != 1) {
        this.pageNumberSuggest -= 1;
      } else {
        this.pageNumberSuggest = obj;
      }

      if (this.showPagesMax11 / 2 < this.pageNumberSuggest) {
        this.showPagesMin11 = this.pageNumberSuggest - 4;
        this.showPagesMax11 = this.pageNumberSuggest + 4;
      } else if (this.showPagesMin11 / 2 < this.pageNumberSuggest) {
        this.showPagesMin11 = this.pageNumberSuggest - 4;
        this.showPagesMax11 = this.pageNumberSuggest + 4;
        if (this.showPagesMax11 < 5) {
          this.showPagesMax11 = 5;
        }
      } else {
        this.showPagesMin11 = 1;
        this.showPagesMax11 = 5;
      }
      this.mergeModalClickReloadChange();
    },
    //code for Data-Tables_
    pageChange(obj) {
      if (obj == "Next") {
        if (this.pageNumber < this.totalPages) {
          this.pageNumber += 1;
        }
      } else if (obj == "Previous" && this.pageNumber != 1) {
        this.pageNumber -= 1;
      } else {
        this.pageNumber = obj;
      }
      //show pagination
      if (this.showPagesMax / 2 < this.pageNumber) {
        this.showPagesMin = this.pageNumber - 4;
        this.showPagesMax = this.pageNumber + 4;
      } else if (this.showPagesMin / 2 < this.pageNumber) {
        this.showPagesMin = this.pageNumber - 4;
        this.showPagesMax = this.pageNumber + 4;
        if (this.showPagesMax < 5) {
          this.showPagesMax = 5;
        }
      } else {
        this.showPagesMin = 1;
        this.showPagesMax = 5;
      }

      const darr = this.currentDateRange.split(" to ");
      let startDate = "";
      let endDate = "";

      if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
      else startDate = new Date(darr[0]);
      endDate = new Date(darr[1]);

      const filter = {
        veinsId: this.mainSearch.searchVeinsId,
        externalId: this.mainSearch.searchExternalId,
        firstName: this.mainSearch.searchFirstName,
        lastName: this.mainSearch.searchLastName,
        phone: this.mainSearch.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        stageId: this.stageId,
      };

      this.intDummyComm();
      this.dummyComm.filter = "";
      this.dummyComm.extras = "";
      this.dummyComm.StageId = this.stageId;
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sort: this.mainSort,
      };

      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/GetStageDisplayFilteredPatients";
      this.axiosGetData(url, myData, 1);
    },
    orderByPay(column) {
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          //
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx < b.pndx ? 1 : b.pndx < a.pndx ? -1 : 0)
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx > b.pndx ? 1 : b.pndx > a.pndx ? -1 : 0)
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx < b.pndx ? 1 : b.pndx < a.pndx ? -1 : 0)
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx > b.pndx ? 1 : b.pndx > a.pndx ? -1 : 0)
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx < b.pndx ? 1 : b.pndx < a.pndx ? -1 : 0)
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx > b.pndx ? 1 : b.pndx > a.pndx ? -1 : 0)
          );
        }
      }
      if (column == 4) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.billNo < b.billNo ? 1 : b.billNo < a.billNo ? -1 : 0)
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.billNo > b.billNo ? 1 : b.billNo > a.billNo ? -1 : 0)
          );
        }
      }
      if (column == 5) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx < b.pndx ? 1 : b.pndx < a.pndx ? -1 : 0)
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.pndx > b.pndx ? 1 : b.pndx > a.pndx ? -1 : 0)
          );
        }
      }
      if (column == 6) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.billDateStr < b.billDateStr
                ? 1
                : b.billDateStr < a.billDateStr
                ? -1
                : 0
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.billDateStr > b.billDateStr
                ? 1
                : b.billDateStr > a.billDateStr
                ? -1
                : 0
          );
        }
      }
      if (column == 7) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.billDateStr < b.billDateStr
                ? 1
                : b.billDateStr < a.billDateStr
                ? -1
                : 0
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.billDateStr > b.billDateStr
                ? 1
                : b.billDateStr > a.billDateStr
                ? -1
                : 0
          );
        }
      }
      if (column == 8) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.amount < b.amount ? 1 : b.amount < a.amount ? -1 : 0)
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.amount > b.amount ? 1 : b.amount > a.amount ? -1 : 0)
          );
        }
      }
      if (column == 9) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.amount < b.amount ? 1 : b.amount < a.amount ? -1 : 0)
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) => (a.amount > b.amount ? 1 : b.amount > a.amount ? -1 : 0)
          );
        }
      }
      if (column == 10) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.refundDateStr < b.refundDateStr
                ? 1
                : b.refundDateStr < a.refundDateStr
                ? -1
                : 0
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.refundDateStr > b.refundDateStr
                ? 1
                : b.refundDateStr > a.refundDateStr
                ? -1
                : 0
          );
        }
      }
      if (column == 11) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.comment < b.comment ? 1 : b.comment < a.comment ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.filteredPaymentRequests = this.filteredPaymentRequests.sort(
            (a, b) =>
              a.comment > b.comment ? 1 : b.comment > a.comment ? -1 : 0
          );
        }
      }
    },
    orderBy(column) {
      //--***sort types=> 0: no sort, 1: asc, 2: desc
      let ms = this.mainSort;
      let mf = ms.name;
      switch (column) {
        case 1: // name & dob
          mf = ms.name;
          switch (mf) {
            case 0:
              this.mainSort.name = 1;
              break;
            case 1:
              this.mainSort.name = 2;
              break;
            case 2:
              this.mainSort.name = 0;
              break;
          }
          this.mainSort.dos = 0;
          this.mainSort.visitType = 0;
          this.mainSort.timein = 0;
          break;
        case 2: // dos
          mf = ms.dos;
          switch (mf) {
            case 0:
              this.mainSort.dos = 1;
              break;
            case 1:
              this.mainSort.dos = 2;
              break;
            case 2:
              this.mainSort.dos = 0;
              break;
          }
          this.mainSort.name = 0;
          this.mainSort.visitType = 0;
          this.mainSort.timein = 0;
          break;
        case 3: // visitType
          mf = ms.visitType;
          switch (mf) {
            case 0:
              this.mainSort.visitType = 1;
              break;
            case 1:
              this.mainSort.visitType = 2;
              break;
            case 2:
              this.mainSort.visitType = 0;
              break;
          }
          this.mainSort.name = 0;
          this.mainSort.dos = 0;
          this.mainSort.timein = 0;
          break;
        case 4: // timein
          mf = ms.timein;
          switch (mf) {
            case 0:
              this.mainSort.timein = 1;
              break;
            case 1:
              this.mainSort.timein = 2;
              break;
            case 2:
              this.mainSort.timein = 0;
              break;
          }
          this.mainSort.name = 0;
          this.mainSort.dos = 0;
          this.mainSort.visitType = 0;
          break;
        default:
          this.mainSort.name = 0;
          this.mainSort.dos = 0;
          this.mainSort.visitType = 0;
          this.mainSort.timein = 0;
          return;
      }

      this.applySearchClick();
      //
    },
    mergeFinalClosed(val) {
      this.showMerge = val;
      //this.loadInit();
    },
    removeHTML(str) {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = str;
      return tmp.textContent || tmp.innerText || "";
    },
    //Email info
    getEmailInfor(emailMessageShort, emailTo, subject) {
      this.GetUserImage();
      this.emailMessage = emailMessageShort;
      //this.emailMessage = this.removeHTML(this.emailMessage);
      //this.emailMessageShort = emailMessageShort;
      this.emailTo = emailTo;
      this.subject = subject;
      $("#emailDetails").modal("show");
    },
    //For Image
    GetUserImage() {
      const str = localStorage.OSversion;
      const arr = str.split("<VEINS2021/>");
      var UserId1 = arr[0];
      const url =
        this.SERVER +
        "/VNSPRAAPI/Practices/GetUserProfilePics?UserProfileId=" +
        UserId1;
      this.axiosGetUserData11(url);
    },
    async axiosGetUserData11(Url) {
      // console.log('GetData');
      await axios({
        method: "get",
        url: Url,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          this.Image = res.data;
        })
        .catch(function(error) {
          //alert(console.log(error));
        })
        .finally(() => {});
    },

    handleRole() {
      //Undefiend
      if (localStorage.EmployeeRolesStr == undefined) return;
      this.EmployeeRolesStr = localStorage.EmployeeRolesStr;
      this.EmployeeRolesStr = JSON.parse(this.EmployeeRolesStr);
      if (this.EmployeeRolesStr.length > 0) {
        this.val = this.EmployeeRolesStr.filter(
          (i) => i.name == "Stage Display"
        );
        if (this.val[0].canUpdate == 0) {
          this.updButton = 0;
        }
        //if(this.val[0].canDelete == 0){ this.delButton = 0;}
      }
    },
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    mergePatientInputStyle() {
      return "background-color: transparent;border-style: none;width: 100%;margin: 0px;padding:0px;";
    },
    requestDeleteClick(pat) {
      Swal.fire({
        icon: "error",
        title: "Are you sure?",
        text:
          "you want to delete this visit and any information related to it.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.value) {
          //const dd = new Date();
          this.intDummyComm();
          //this.activeStageNdx == xx;

          const stageid = this.stageId;
          this.dummyComm.pageNumber = this.pageNumber;
          this.dummyComm.pageSize = this.pageSize;
          this.dummyComm.filter = "";
          this.dummyComm.visitId = pat.visitId;
          this.dummyComm.NextStageId = 0;
          this.dummyComm.StageId = this.stageId;
          //********Stageid
          this.dummyComm.modelFrom = 1;
          this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
          this.dummyComm.filter = "";

          const darr = this.currentDateRange.split(" to ");
          let startDate = "";
          let endDate = "";

          if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
          else startDate = new Date(darr[0]);
          endDate = new Date(darr[1]);

          const filter = {
            veinsId: this.mainSearch.searchVeinsId,
            externalId: this.mainSearch.searchExternalId,
            firstName: this.mainSearch.searchFirstName,
            lastName: this.mainSearch.searchLastName,
            phone: this.mainSearch.searchPhone,
            startDate: this.dateToYMD(startDate) + "",
            endDate: this.dateToYMD(endDate) + "",
            stageId: this.stageId,
          };

          const myData = {
            dc: this.dummyComm,
            filter: filter,
            sort: this.mainSort,
          };
          const url = this.SERVER + "/VNSPRAAPI/Trackers/DelPatient";
          this.axiosGetData(url, myData, 31);
        }
      });
    },
    deleteStepClick(step, pat) {
      ////console.log("deleteStepClick", step);
      this.isDelStepPressed = true;
      Swal.fire({
        icon: "error",
        title: "Are you sure?",
        text:
          "After you Delete this Step. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.value) {
          //const dd = new Date();
          this.intDummyComm();
          this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
          this.dummyComm.visitId = pat.visitId;
          this.dummyComm.stageId = step.stageId;
          this.dummyComm.stepId = step.stepId;
          const url = this.SERVER + "/VNSPRAAPI/Trackers/DelStep";
          const myData = this.dummyComm;
          this.deleteStepAxios(url, myData, step, pat);
          //this.axiosGetData(url, myData, 27);
          // this.successToastUpd();
        }
      });
    },
    async deleteStepAxios(url, myData, step, pat) {
      console.log(step);
      await axios({
        method: "post",
        url: url,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const obj = res.data;
          if (obj.status === true) {
            this.successToastUpd();
            // this.$nextTick(() => {

            const StepUpdated = obj.data;
            step.pndx = StepUpdated.pndx;
            step.visitId = StepUpdated.visitId;
            (step.stageId = StepUpdated.stageId),
              (step.stepStartTime = StepUpdated.stepStartTime);
            step.stepStartTimeStr = StepUpdated.stepStartTimeStr;
            step.stepName = StepUpdated.stepName;
            step.stepTimeLimit = StepUpdated.stepTimeLimit;
            step.stepEndTime = StepUpdated.stepEndTime;
            step.status = parseInt(StepUpdated.status);
            step.operatorId = StepUpdated.operatorId;
            step.operatorName = StepUpdated.operatorName;
            // });
          } else {
            this.errorToastUpd(obj.message);
            $("#moveNext-" + pat.patientId + "-" + step.stepId).prop(
              "disabled",
              false
            );
          }
        })
        .catch(function(error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          // this.connection
          //   .invoke("FetchDataAll", this.MyUserId)
          //   .catch(console.error);
          this.callApiForRefreah();
          this.ResetLogoutTime();
          this.calcTimerRoutine();
        });
    },
    questOptionSelected(quest, opt) {
      quest.answer = opt.questOptionId;
    },
    demoOptionSelected(demo, opt, what = "") {
      if (what == "check-box") {
        const ans = opt.questOptionId + "";
        let arr = demo.answer.split(",");
        if (arr.includes(ans)) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i] == ans) {
              arr.splice(i, 1);
              i--;
            }
          }
        } else arr.push(ans);
        demo.answer = arr.toString();
      } else demo.answer = opt.questOptionId;
    },
    moveToNextStep(pat, step) {
      $("#moveNext-" + pat.patientId + "-" + step.stepId).prop(
        "disabled",
        true
      );
      if (pat.patientId == 0) {
        $("#moveNext").prop("disabled", true);
        return;
      }
      if (this.updButton == 1) {
        // if (this.isDelStepPressed) {
        //   this.isDelStepPressed = false;
        //   return;
        // }
        if (step.status == 1) {
          //active
          this.closeStep(pat, step);
          return;
        } else if (step.status == 2) {
          //complete
          this.ShowErrorAutoClose("Step already completed.");
          return;
        }
        if (step.status !== "") return;
        if (pat.patientId <= 0) {
          this.ShowErrorAutoClose("Patient not Merged.");
          return;
        }

        //+++
        const dd = new Date();
        step.stepStartTime = dd;
        this.intDummyComm();
        this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
        this.dummyComm.pageNumber = this.pageNumber;
        this.dummyComm.extras1 = this.practName;
        this.dummyComm.pageSize = this.pageSize;
        this.dummyComm.filter = "";
        this.dummyComm.patientId = pat.patientId;
        this.dummyComm.emailValue = pat.email;
        this.dummyComm.smsValue = pat.phone;
        this.dummyComm.filter = "";

        this.dummyComm.extras =
          this.dateToSqlServerDateFormat(dd) +
          this.UKEY +
          pat.visitId +
          this.UKEY +
          step.stageId +
          this.UKEY +
          step.stepId;

        const darr = this.currentDateRange.split(" to ");
        let startDate = "";
        let endDate = "";

        if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
        else startDate = new Date(darr[0]);
        endDate = new Date(darr[1]);

        const filter = {
          veinsId: this.mainSearch.searchVeinsId,
          externalId: this.mainSearch.searchExternalId,
          firstName: this.mainSearch.searchFirstName,
          lastName: this.mainSearch.searchLastName,
          phone: this.mainSearch.searchPhone,
          startDate: this.dateToYMD(startDate) + "",
          endDate: this.dateToYMD(endDate) + "",
          stageId: step.stageId,
        };

        const myData = {
          dc: this.dummyComm,
          filter: filter,
          sort: this.mainSort,
        };
        const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdateStep";
        this.UpdateStepAxios(url, myData, step, pat); /*== 6*/
      }
    },
    async UpdateStepAxios(url, myData, step, pat) {
      console.log(step);
      await axios({
        method: "post",
        url: url,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const obj = res.data;
          if (obj.status === true) {
            this.successToastUpd();
            // this.$nextTick(() => {
            const StepUpdated = obj.data;
            step.pndx = StepUpdated.pndx;
            step.visitId = StepUpdated.visitId;
            (step.stageId = StepUpdated.stageId),
              (step.stepStartTime = StepUpdated.stepStartTime);
            step.stepStartTimeStr = StepUpdated.stepStartTimeStr;
            step.stepName = StepUpdated.name;
            step.stepTimeLimit = StepUpdated.stepTimeLimit;
            step.stepEndTime = StepUpdated.stepEndTime;
            step.status = "1"; //StepUpdated.status;
            step.operatorId = StepUpdated.operatorId;
            step.operatorName = StepUpdated.operatorName;
            // });
          } else if (obj.status === false && obj.error === false) {
            this.errorToastUpd(obj.message);
            this.loadInitWithoutLoad();
            //
          } else {
            this.errorToastUpd(obj.message);
            $("#moveNext-" + pat.patientId + "-" + step.stepId).prop(
              "disabled",
              false
            );
          }
        })
        .catch(function(error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          // this.connection
          //   .invoke("FetchDataAll", this.MyUserId)
          //   .catch(console.error);
          this.callApiForRefreah();
          this.ResetLogoutTime();
          this.calcTimerRoutine();
        });
    },
    callApiForRefreah() {
      clearTimeout(this.RefreashObj);
      this.RefreashObj = setTimeout(() => {
        this.CallFetchDataPatients();
      }, 3000);
    },
    moveToStartStep(pat, step) {
      $("#moveStart-" + pat.patientId + "-" + step.stepId).prop(
        "disabled",
        true
      );
      // // eslint-disable-line no-//
      // if (pat.patientId == 0 || pat.physicianId == -1) {
      //   $("#moveNext").prop("disabled", true);
      //   return;
      // }
      // if (this.updButton == 1) {
      //   if (this.isDelStepPressed) {
      //     this.isDelStepPressed = false;
      //     return;
      //   }
      //   if (step.status == 1) {
      //     //active
      //     this.closeStep(pat, step);
      //     return;
      //   } else if (step.status == 2) {
      //     //complete
      //     this.ShowErrorAutoClose("Step already completed.");
      //     return;
      //   }
      // if (step.status !== "") return;
      // if (pat.patientId <= 0) {
      //   this.ShowErrorAutoClose("Patient not Merged.");
      //   return;
      // }

      //+++
      const dd = new Date();
      step.stepStartTime = dd;
      this.intDummyComm();
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.extras1 = this.practName;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = "";
      this.dummyComm.patientId = pat.patientId;
      this.dummyComm.emailValue = pat.email;
      this.dummyComm.smsValue = pat.phone;
      this.dummyComm.filter = "";

      this.dummyComm.extras =
        this.dateToSqlServerDateFormat(dd) +
        this.UKEY +
        pat.visitId +
        this.UKEY +
        step.stageId +
        this.UKEY +
        step.stepId;

      const darr = this.currentDateRange.split(" to ");
      let startDate = "";
      let endDate = "";

      if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
      else startDate = new Date(darr[0]);
      endDate = new Date(darr[1]);

      const filter = {
        veinsId: this.mainSearch.searchVeinsId,
        externalId: this.mainSearch.searchExternalId,
        firstName: this.mainSearch.searchFirstName,
        lastName: this.mainSearch.searchLastName,
        phone: this.mainSearch.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        stageId: step.stageId,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sort: this.mainSort,
      };
      const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdateStepD";
      this.UpdateStepAxios(url, myData, step, pat); //6
    },
    checkOutClick(pat) {
      clearTimeout(this.loadObj);
      //  $("#v-" + pat.visitId + "").prop("disabled", true);
      this.intDummyComm();

      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.emailValue = pat.email;
      this.dummyComm.smsValue = pat.phone;
      this.dummyComm.visitId = pat.visitId;
      this.dummyComm.NextStageId = 0;
      this.dummyComm.StageId = this.stageId;
      this.dummyComm.modelFrom = 1;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.dummyComm.filter = "";

      const darr = this.currentDateRange.split(" to ");
      let startDate = "";
      let endDate = "";

      if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
      else startDate = new Date(darr[0]);
      endDate = new Date(darr[1]);

      const filter = {
        veinsId: this.mainSearch.searchVeinsId,
        externalId: this.mainSearch.searchExternalId,
        firstName: this.mainSearch.searchFirstName,
        lastName: this.mainSearch.searchLastName,
        phone: this.mainSearch.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        stageId: this.stageId,
      };
      pat.nextStageCheck = true;

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sort: this.mainSort,
      };
      const url = this.SERVER + "/VNSPRAAPI/Trackers/PatCheckOutAsync";
      this.GetCheckOutPatient(url, myData, 1001, pat.visitId, pat);
    },
    async GetCheckOutPatient(URL, myData, what, nextButtonId, pat) {
      await axios({
        //usman
        method: "post",
        url: URL,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          //999** if everything goes well -- we will get data
          const reponse = res.data;
          if (reponse.auditFlag === 1) {
            this.allFilterPatients = this.allFilterPatients.filter((x) => {
              return x.visitId != reponse.visitId;
            });
          } else {
            console.log(res);
            // $("#v-" + nextButtonId + "").prop("disabled", false);
            pat.nextStageCheck = false;
          }
        })
        .catch(function(error) {
          if (error.response) {
            pat.nextStageCheck = false;
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          pat.nextStageCheck = false; //  $("#v-" + nextButtonId + "").prop("disabled", false);
          this.ResetLogoutTime();
          this.calcTimerRoutine();
          this.CallFetchDataPatients();
          // clearTimeout(this.loadObj);
          // this.loadObj = setInterval(this.loadInitWithoutLoad, this.intervalTime);
          //  const myUrl= this.SERVER + "/VNSPRAAPI/Trackers/GetStageDisplayFilteredPatients";
          //   this.axiosGetData(myUrl,myData,1001);
        });
    },
    deletePayment(pay) {
      Swal.fire({
        title: "Are you sure?",
        text:
          "You want to Delete this Payment. This action \n cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.value) {
          this.intDummyComm();
          this.dummyComm.extras = pay.status;
          this.dummyComm.visitId = pay.visitId;
          this.dummyComm.patientId = pay.patientId;
          const obj = {
            DC: this.dummyComm,
            PR: pay,
          };

          const url = this.SERVER + "/VNSPRAAPI/Trackers/DeletePayment";
          this.axiosGetData(url, obj, 9001);
        }
      });
    },
    //~~jumpToNamedStage
    jumpToNamedStage(ndx, pat) {
      clearInterval(this.loadObj);
      // $("#v-" + pat.visitId + "").prop("disabled", true);
      //this.aSingleStage = JSON.parse(JSON.stringify(this.activeStageNdx));
      var nextStageId = JSON.parse(JSON.stringify(this.stagesSteps[ndx]));
      this.intDummyComm();

      //this.activeStageNdx == xx;
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.emailValue = pat.email;
      this.dummyComm.smsValue = pat.phone;
      this.dummyComm.visitId = pat.visitId;
      this.dummyComm.patientId = pat.patientId;
      this.dummyComm.extras1 = this.practName;
      this.dummyComm.NextStageId = nextStageId.stageId;
      this.dummyComm.StageId = this.stageId;
      this.dummyComm.modelFrom = 1;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.dummyComm.filter = "";

      const darr = this.currentDateRange.split(" to ");
      let startDate = "";
      let endDate = "";

      if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
      else startDate = new Date(darr[0]);
      endDate = new Date(darr[1]);

      const filter = {
        veinsId: this.mainSearch.searchVeinsId,
        externalId: this.mainSearch.searchExternalId,
        firstName: this.mainSearch.searchFirstName,
        lastName: this.mainSearch.searchLastName,
        phone: this.mainSearch.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        stageId: this.stageId,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sort: this.mainSort,
      };
      pat.nextStageCheck = true;
      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/UpdatePatientCurrentStageAsync";
      this.jumpToNextStageAxios(url, myData, 1001, pat);
      //location.reload();
    },

    mainTabActiveClass(ndx) {
      if (ndx == this.activeStageNdx) return "nav-link active";
      else return "nav-link";
    },
    //~~jumpToNextStage
    jumpToNextStage(pat) {
      try {
        // $("#v-" + pat.visitId + "").prop("disabled", true);

        //const xx = this.activeStageNdx;
        // if (this.stagesSteps.length > xx) {
        this.aSingleStage = JSON.parse(
          JSON.stringify(this.stagesSteps[this.activeStageNdx])
        );
        this.intDummyComm();
        //this.activeStageNdx == xx;

        const stageid = this.stageId;
        this.dummyComm.pageNumber = this.pageNumber;
        this.dummyComm.extras1 = this.practName;
        this.dummyComm.pageSize = this.pageSize;
        this.dummyComm.emailValue = pat.email;
        this.dummyComm.smsValue = pat.phone;
        this.dummyComm.filter = "";
        this.dummyComm.visitId = pat.visitId;
        this.dummyComm.patientId = pat.patientId;
        this.dummyComm.NextStageId = 0;
        this.dummyComm.StageId = this.stageId;
        //********Stageid
        this.dummyComm.modelFrom = 1;
        this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
        this.dummyComm.filter = "";

        const darr = this.currentDateRange.split(" to ");
        let startDate = "";
        let endDate = "";

        if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
        else startDate = new Date(darr[0]);
        endDate = new Date(darr[1]);

        const filter = {
          veinsId: this.mainSearch.searchVeinsId,
          externalId: this.mainSearch.searchExternalId,
          firstName: this.mainSearch.searchFirstName,
          lastName: this.mainSearch.searchLastName,
          phone: this.mainSearch.searchPhone,
          startDate: this.dateToYMD(startDate) + "",
          endDate: this.dateToYMD(endDate) + "",
          stageId: this.stageId,
        };

        const myData = {
          dc: this.dummyComm,
          filter: filter,
          sort: this.mainSort,
        };
        pat.nextStageCheck = true;
        const url =
          this.SERVER + "/VNSPRAAPI/Trackers/UpdatePatientCurrentStageAsync";
        this.jumpToNextStageAxios(url, myData, 1001, pat);
        //}
      } catch {
        /**/
      }
    },
    async jumpToNextStageAxios(URL, Data, What, pat) {
      //usman
      await axios({
        method: "post",
        url: URL,
        data: Data,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          //999** if everything goes well -- we will get data

          const reponse = res.data;
          if (reponse.auditFlag === 1) {
            this.allFilterPatients = this.allFilterPatients.filter((x) => {
              return x.visitId != reponse.visitId;
            });
          } else {
            console.log(res);
            // $("#v-" + nextButtonId + "").prop("disabled", false);
            this.showErrorToast("unable to change stage.please try again!");
            pat.nextStageCheck = false;
          }
        })
        .catch(function(error) {
          if (error.response) {
            pat.nextStageCheck = false;
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          pat.nextStageCheck = false; //  $("#v-" + nextButtonId + "").prop("disabled", false);
          this.ResetLogoutTime();
          this.calcTimerRoutine();
          this.CallFetchDataPatients();

          // clearTimeout(this.loadObj);
          // this.loadObj = setInterval(this.loadInitWithoutLoad, this.intervalTime);
          //  const myUrl= this.SERVER + "/VNSPRAAPI/Trackers/GetStageDisplayFilteredPatients";
          //   this.axiosGetData(myUrl,myData,1001);
        });
    },
    getStepStartDate(step) {
      const dd = new Date(step.stepStartTime);
      return dd.toLocaleDateString();
    },
    getStepStartTime(step) {
      const dd = new Date(step.stepStartTime);
      return dd.toLocaleTimeString();
    },
    getDiffOperatorName(operatorId) {
      let x = "";
      try {
        const xx = this.operators.find((f) => f.operatorId == operatorId);
        x = xx.operatorName;
      } catch {
        x = "";
      }
      return x;
    },
    getDiffOperatorName_1(operatorId) {
      if (operatorId == 0) {
        this.Ownername = localStorage.getItem("UserName");
      }
      return this.Ownername;
    },
    stepOverdueClass(isOverdue, step) {
      if (isOverdue == true && step.status !== 2) {
        return "btn btn-block btn-sm btn-outline-info mytooltip stepAcknowledge";
      } else {
        if (step.status == 1)
          // active
          return "btn btn-block btn-sm btn-outline-info stepAcknowledge";
        else if (step.status == 2)
          // complete
          return "btn btn-block btn-sm btn-outline-success stepAcknowledge";
      }
    },
    datePicker() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function(start, end) {
          ////console.log(start,end)
          if (!start) {
            self.startDate = new Date();
            self.endDate = new Date();
            // self.initDate_1 =
            //   self.dateToMDY(self.startDate) +
            //   " - " +
            //   self.dateToMDY(self.endDate);
          }
          self.startDate = new Date(start);
          self.endDate = new Date(end);
          // self.initDate_1 =
          //   self.dateToMDY(self.startDate) +
          //   " - " +
          //   self.dateToMDY(self.endDate);
        }
      );
    },
    datePicker_1() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function(start, end) {
          self.startDate_1 = new Date(start);
          self.endDate_1 = new Date(end);
          self.initDate =
            self.dateToMDY(self.startDate_1) +
            " - " +
            self.dateToMDY(self.endDate_1);
        }
      );
    },
    datePicker_2() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function(start, end) {
          self.startDate_2 = new Date(start);
          self.endDate_2 = new Date(end);
          self.initDate_2 =
            self.dateToMDY(self.startDate_2) +
            " - " +
            self.dateToMDY(self.endDate_2);
        }
      );
    },
    datePicker_3() {
      const self = this;
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "left",
        },
        function(start, end) {
          self.startDate_3 = new Date(start);
          self.endDate_3 = new Date(end);
          self.initDate_3 =
            self.dateToMDY(self.startDate_3) +
            " - " +
            self.dateToMDY(self.endDate_3);
        }
      );
    },
    sendReceiptClick() {
      this.intDummyComm();
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      const url = this.SERVER + "/VNSPRAAPI/Payments/SendReceiptReminder";
      const myData = this.SendReceiptRequest;
      myData.DC = this.dummyComm;
      this.axiosGetData(url, myData, 9002);
    },
    chatSmsSent() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.extras2 = this.aSingleText.userId;

      const url = this.SERVER + "/VNSPRAAPI/Patient/SendSMS";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      const dc = this.dummyComm;
      const Sms = {
        PhoneNumber: this.aSinglePatient.phone,
        MessageBody: this.chatSms,
        PatientID: this.aSinglePatient.patientId,
        UserId: 0,
        VisitId: this.aSinglePatient.visitId,
        LocalTime: new Date(),
      };
      const myData = {
        dc: dc,
        Sms: Sms,
      };
      this.axiosGetData(url, myData, 32);
    },
    smsContactClick(User) {
      this.aSingleText.userId = User.userId;
      if (User.userId > 0) this.aSingleText = JSON.parse(JSON.stringify(User));
      else
        this.aSingleText = {
          userId: 0,
        };
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetUserSmsHist";
      this.intDummyComm();
      this.dummyComm.extras = this.aSinglePatient.visitId;
      this.dummyComm.visitId = this.aSingleText.userId;
      this.axiosGetData(url, this.dummyComm, 24);
    },
    sendEmail() {
      if (this.aSingleEmail.name == "") {
        this.ShowWarning("Name is require");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.email == "") {
        this.ShowWarning("Email is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleEmail.emailText == "") {
        this.ShowWarning("Text is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleEmail.emailSubject == "") {
        this.ShowWarning("Subject is require");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.email != null) {
        if (!this.validEmail(this.aSinglePatient.email)) {
          this.Validity(this.e);
        }
      }
      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      const url = this.SERVER + "/VNSPRAAPI/Patient/SendEmail";
      const EmailData = {
        SentTo: this.aSinglePatient.email,
        SentFrom: "",
        Password: "",
        Body: this.aSingleEmail.emailText,
        Subject: this.aSingleEmail.emailSubject,
        TemplateName: this.aSingleEmail.name,
        UserId: this.dummyComm.ownerId,
        OwnerId: this.dummyComm.ownerId,
        PracticeId: this.dummyComm.practiceId,
        PatientId: this.aSinglePatient.patientId,
        VisitId: this.aSinglePatient.visitId,
        SentLocal: new Date(),
        //SentServer:
      };
      const myObject = {
        dc: this.dummyComm,
        email: EmailData,
      };
      this.axiosGetData(url, myObject, 23);
    },
    sendReminderClick() {
      if (this.Reminder.email == "") {
        this.showErrorToast("Email is require");
        return;
      }
      if (this.Reminder.phone == "") {
        this.showErrorToast("Phone is require");
        return;
      }

      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());

      const Reminder1 = {
        PNDX: this.Reminder.pndx,
        BillNo: this.Reminder.billNo,
        VisitId: this.Reminder.visitId,
        PatientId: this.Reminder.patientId,
        Amount: this.Reminder.amount,
        Email: this.Reminder.email,
        Phone: this.Reminder.phone,
      };

      const myData = { dc: this.dummyComm, pr: Reminder1 };
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SendPaymntReminder";
      this.axiosGetData(url, myData, 9000);
    },
    SendSms() {
      if (this.aSingleSms.name == "") {
        this.ShowWarning("Name is require");
        event.preventDefault();
        return;
      }
      if (this.aSinglePatient.phone == "") {
        this.ShowWarning("Phone is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleSms.smsText == "") {
        this.ShowWarning("Text is require");
        event.preventDefault();
        return;
      }
      this.intDummyComm();
      this.dummyComm.extras = "";
      const url = this.SERVER + "/VNSPRAAPI/Patient/SendSMS";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      const dc = this.dummyComm;
      const Sms = {
        PhoneNumber: this.aSinglePatient.phone,
        MessageBody: this.aSingleSms.smsText,
        PatientID: this.aSinglePatient.patientId,
        UserId: 0,
        VisitId: this.aSinglePatient.visitId,
        LocalTime: new Date(),
      };
      const myData = {
        dc: dc,
        Sms: Sms,
      };
      this.axiosGetData(url, myData, 32);
    },
    // saveAction(what) {
    //   if (what == "sms") {
    //     if (this.aSingleSms.name == "") {
    //       this.ShowWarning("Name is require");
    //       event.preventDefault();
    //       return;
    //     }
    //     if (this.aSinglePatient.phone == "") {
    //       this.ShowWarning("Phone is require");
    //       event.preventDefault();
    //       return;
    //     }
    //     if (this.aSingleSms.smsText == "") {
    //       this.ShowWarning("Text is require");
    //       event.preventDefault();
    //       return;
    //     }
    //   }
    //   const dd = new Date();
    //   let action = {
    //     PNDX: this.aSinglePatient.pndx,
    //     patientId: this.aSinglePatient.patientId,
    //     visitId: this.aSinglePatient.visitId,
    //     actionType: what,
    //     actionDate: dd.toLocaleDateString() + " " + dd.toLocaleTimeString(),
    //   };
    //   const url = this.SERVER + "/VNSPRAAPI/Trackers/SavAct";
    //   this.intDummyComm();
    //   switch (what) {
    //     case "sms":
    //       action.sentTo = this.aSinglePatient.phone;
    //       action.actionText = this.aSingleSms.smsText;
    //       break;
    //     case "email":
    //       action.sentTo = this.aSinglePatient.email;
    //       action.actionText = this.aSingleEmail.emailText;
    //       action.subject = this.aSingleEmail.emailSubject;
    //       break;
    //   }
    //   const myData = {
    //     dc: this.dummyComm,
    //     action: action,
    //   };
    //   this.axiosGetData(url, myData, 23);
    // },
    sendTextClick(pat) {
      // this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      //console.log(pat);
      if (this.smsTempsList.length <= 0) {
        this.intDummyComm();
        const url = this.SERVER + "/VNSPRAAPI/Trackers/GetTxtTem";
        const myData = this.dummyComm;
        this.axiosGetData(url, myData, 22);
      } else $("#sendText").modal({ backdrop: "static", keyboard: false });
    },
    sendEmailClick(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailTemps";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 15);
    },
    sendTextModalClose() {
      $("#sendText").modal("hide");
    },
    smsTempsListClick(sms) {
      if (sms.name != "Compose") {
        this.Enumber = true;
        this.Esubj1 = true;
        this.Ename1 = true;
      } else {
        this.Enumber = false;
        this.Esubj1 = false;
        this.Ename1 = false;
      }
      this.selectedSmsId = sms.smsTemplateId;
      if (sms.smsTemplateId > 0)
        this.aSingleSms = JSON.parse(JSON.stringify(sms));
      else this.aSingleSms = { name: "", smsTemplateId: 0, smsText: "" };
    },
    emailTempsListClick(email) {
      if (email.name != "Compose") {
        this.Eemail = true;
        this.Esubj = true;
        this.setReadonly = true;
        this.Ename = true;
      } else {
        this.Eemail = false;
        this.Esubj = false;
        this.setReadonly = false;
        this.Ename = false;
      }
      this.aSingleEmail.emailTemplateId = email.emailTemplateId;
      if (email.emailTemplateId > 0)
        this.aSingleEmail = JSON.parse(JSON.stringify(email));
      else
        this.aSingleEmail = {
          name: "",
          emailTemplateId: 0,
          emailSubject: "",
          email: "",
          emailText: "",
        };
    },
    selectedSmsTempClass(sms) {
      if (sms.smsTemplateId === 0)
        return "list-group-item list-group-item-action btn-success";
      else {
        if (this.selectedSmsId == sms.smsTemplateId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },
    selectedSmsTempIcon(sms) {
      if (sms.smsTemplateId == 0) return "fas fa-envelope mr-3";
      else return "far fa-file-alt mr-3";
    },
    selectedEmailTempIcon(email) {
      if (email.emailTemplateId == 0) return "fas fa-envelope mr-3";
      else return "far fa-file-alt mr-3";
    },
    clickSmsLis(sms) {
      if (sms.userId === 0)
        return "list-group-item list-group-item-action btn-success";
      else {
        if (this.aSingleText.userId == sms.userId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },
    selectedEmailTempClass(email) {
      if (email.emailTemplateId === 0)
        return "list-group-item list-group-item-action btn-success";
      else {
        if (this.aSingleEmail.emailTemplateId == email.emailTemplateId)
          return "list-group-item list-group-item-action active show";
        else return "list-group-item list-group-item-action show";
      }
    },
    updateResourcesClick() {
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.extras = this.aSinglePatient.visitId;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdateResources";
      const myData = { dc: this.dummyComm, rs: this.patResSumm };
      this.axiosGetData(url, myData, 21);
    },
    resourceidmodalClick(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.intDummyComm();
      this.dummyComm.extras = pat.visitId;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetResourceSummary";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 20);
      this.p_visitId = pat.visitId;
      this.showResourceComponentDialog = true;
      // this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      // this.intDummyComm();
      // this.dummyComm.extras = pat.visitId;
      // const url = this.SERVER + "/VNSPRAAPI/Trackers/GetResourceSummary";
      // const myData = this.dummyComm;
      // this.axiosGetData(url, myData, 20);
    },
    paymentReminderClick() {
      // const dd = new Date();
      // this.paymentReminder.actionDate =
      // dd.toISOString().slice(0, 10) + " " + dd.toLocaleTimeString();
      // this.paymentReminder.visitId = this.aSinglePatient.visitId;
      if (this.paymentReminder.phone.length == 0) {
        this.ShowWarning("Enter Phone number");
        event.preventDefault();
        return;
      } else if (this.paymentReminder.phone.length < 12) {
        this.ShowWarning("Phone number length must be 10");
        event.preventDefault();
        return;
      } else if (this.paymentReminder.email.length == 0) {
        this.ShowWarning("Enter Email");
        event.preventDefault();
        return;
      } else if (this.paymentReminder.email.length > 0) {
        if (this.paymentReminder.email != null) {
          if (!this.validEmail(this.paymentReminder.email)) {
            this.Validity(this.e);
          }
        }
      }
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      const Reminder = {
        patientId: this.aSingleRequestPayment.patientId,
        pndx: this.aSingleRequestPayment.pndx,
        firstName: this.aSinglePatient.firstName,
        lastName: this.aSinglePatient.lastName,
        status: this.allFilterPatients_1[0].inputStatus,
        amount: this.aSingleRequestPayment.amount,
        phoneNo: this.paymentReminder.phone,
        email: this.paymentReminder.email,
        dummy: this.dummyComm.extras,
      };
      const url = this.SERVER + "/VNSPRAAPI/Patient/ReminderEmailSms";
      //const myData = { dc: this.dummyComm, pr: pr };
      const myData = {
        Reminder: Reminder,
        dc: this.dummyComm,
      };
      this.axiosGetData(url, myData, 19);
    },
    collectPayment(rp) {
      this.aSinglePaymentReceived = {
        pndx: 0,
        patientId: 0,
        practiceId: 0,
        visitId: rp.visitId,
        billNo: 0,
        collectedBy: 0,
        paymentDate: new Date(),
        amount: rp.amount,
        paymentMethod: "",
        holderName: "",
        tdNumber: "",
        cardCVC: "",
        comment: "",
        zip: "",
      };
      this.aSingleRequestPayment.amount = this.aSinglePaymentReceived.amount;
      $("#paymentMethodv2").modal("show");
    },
    getPaymentEmailPhone(visitId) {
      this.intDummyComm();
      this.dummyComm.visitId = visitId;
      const myData = this.dummyComm;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailPhone";
      this.axiosGetData(url, myData, 189);
    },
    requestPaymentClick(pat, what) {
      if (what > 0) this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetLstPayReq";
      this.dummyComm.visitId = pat.visitId;
      this.PvisitId = pat.visitId;
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 18);
    },
    requestPaymentClick_2(pat, what) {
      if (what > 0) this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetLstPayReq";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 188);
    },
    saveInsuranceClick() {
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      let obj = {
        pndx: 0,
        visitId: 0,
        patientId: 0,
        primaryInsurance: "",
        primaryInsuranceNo: "",
        primaryInsuranceGroupId: "",
        primaryInsuranceId: "",
        secondaryInsurance: "",
        secondaryInsuranceNo: "",
        secondaryInsuranceGroupId: "",
        secondaryInsuranceId: "",
      };
      //var firstfile = $("#customFileLang_f").val();
      //var Secfile = $("#customFileLang_s").val();
      var firstfile = $("#customFileLang_fl").html();
      var Secfile = $("#customFileLang_sl").html();
      obj = this.aSinglePatient.insurance;
      obj.patientId = this.dummyComm.patientId;
      obj.visitId = this.aSinglePatient.pndx;
      obj.primaryInsuranceId = firstfile;
      obj.secondaryInsuranceId = Secfile;
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.extras = this.aSinglePatient.visitId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      const url = this.SERVER + "/VNSPRAAPI/Patient/SavePatientInsurance";
      const myData = {
        dc: this.dummyComm,
        patientInsuranceInfo: obj,
      };
      this.axiosGetData(url, myData, 17);
    },
    updateDetailsClick() {
      //For validation
      if (this.aSinglePatient.firstName == "") {
        this.ShowWarning("Firstname is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.lastName == "") {
        this.ShowWarning("Lastname is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.dob == "") {
        this.ShowWarning("Date of Birth is require");
        event.preventDefault();
        return;
      } else if (this.aSinglePatient.gender == "0") {
        this.ShowWarning("Gender is require");
        event.preventDefault();
        return;
      }
      if (!this.isValidateDate(this.aSinglePatient.dob)) {
        this.ShowWarning("Valid Date of Birth required");
        event.preventDefault();
        return;
      }

      if (this.aSinglePatient.email != null) {
        if (!this.validEmail(this.aSinglePatient.email)) {
          this.Validity(this.e);
        }
      }
      if (
        this.aSinglePatient.streetAddress == "undefined" ||
        this.aSinglePatient.streetAddress == ""
      ) {
        this.aSinglePatient.address = "";
      }

      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.filter = "";
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      const darr = this.currentDateRange.split(" to ");
      let startDate = "";
      let endDate = "";

      if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
      else startDate = new Date(darr[0]);
      endDate = new Date(darr[1]);

      const filter = {
        veinsId: this.mainSearch.searchVeinsId,
        externalId: this.mainSearch.searchExternalId,
        firstName: this.mainSearch.searchFirstName,
        lastName: this.mainSearch.searchLastName,
        phone: this.mainSearch.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        stageId: this.stageId,
      };
      const url = this.SERVER + "/VNSPRAAPI/Patient/SavePatientBasicInfo";
      const myData = {
        dc: this.dummyComm,
        patientInfo: this.aSinglePatient,
        filter: filter,
        sort: this.mainSort,
      };
      this.axiosGetData(url, myData, 5002);
    },
    loader_1() {
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
    },
    showProfilPopUpBro(pat) {
      console.log(pat);
      if (pat.patientId < 0) {
        return;
      }
      this.showProfilePopupVar = true;

      this.$nextTick(() => {
        $("#newptModalCom").modal("show");
        this.$refs.patientComponent.getPatientData(pat);
        this.removeModalBackdrop();
      });
    },
    removeModalBackdrop() {
      this.$nextTick(() => {
        $("#newptModalCom").on("shown.bs.modal", function(e) {
          $(document).off("focusin.modal");
        });
      });
    },
    showProfilePopup(pat, what) {
      if (pat.patientId < 0) {
        return;
      }
      this.endDate_2 = new Date();
      this.startDate_2 = new Date();
      this.startDate_2.setDate(this.startDate_2.getDate() - 365);
      this.initDate_2 =
        this.dateToMDY(this.startDate_2) +
        " - " +
        this.dateToMDY(this.endDate_2);
      this.endDate_1 = new Date();
      this.startDate_1 = new Date();
      this.startDate_1.setDate(this.startDate_1.getDate() - 365);
      this.initDate =
        this.dateToMDY(this.startDate_1) +
        " - " +
        this.dateToMDY(this.endDate_1);
      this.endDate_3 = new Date();
      this.startDate_3 = new Date();
      this.startDate_3.setDate(this.startDate_3.getDate() - 365);
      this.initDate_3 =
        this.dateToMDY(this.startDate_3) +
        " - " +
        this.dateToMDY(this.endDate_3);
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");

      $("#detailsC").click();
      var date = moment(String(this.aSinglePatient.dob)).format("YYYY-MM-DD");
      this.val3 = moment(String(this.aSinglePatient.dob)).format("MM/DD/YYYY");
      this.val1 = this.aSinglePatient.dos.split("T")[0];
      this.val2 = this.val1.split("-")[0].substring(2, 4);
      this.val1 = this.val1.split("-")[1];
      if (this.val1.length == 1) {
        this.val1 = "0" + this.val1;
      }
      this.aSinglePatient.dob = date + "";
      this.intDummyComm();
      let url = this.SERVER + "/VNSPRAAPI/Trackers/GetEmailTemps";
      let myData = this.dummyComm;
      //this.axiosGetData(url, myData, 15);
      this.intDummyComm();
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = "";
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      url = this.SERVER + "/VNSPRAAPI/Patient/GetSnglPatAllData";
      myData = this.dummyComm;
      this.axiosGetData(url, myData, 14);

      console.log(this.aSinglePatient);
      if (what == "text") $("#textHistory1221").click();
      else if (what == "email") $("#emailHistory1221").click();
      else if (what == "payment") $("#paymentHistory").click();
      //$("#newptModal").modal("show");
    },
    paymentCollectMethodModal(pay) {
      this.displayPayMethod = true;
      this.ActivePaymentRequest = pay;
      this.limitAmount = pay.amount;
      this.aSinglePaymentReceived.amount = this.ActivePaymentRequest.amount;
    },
    savePaymentRequest() {
      var valueAmount = String(this.aSingleRequestPayment.amount);
      if (this.aSingleRequestPayment.phone == "") {
        this.ShowWarning("Phone is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleRequestPayment.phone.length < 12) {
        this.ShowWarning("Phone length must be 10");
        event.preventDefault();
        return;
      }
      if (this.aSingleRequestPayment.email == "") {
        this.ShowWarning("Email is require");
        event.preventDefault();
        return;
      }
      if (valueAmount == "") {
        this.ShowWarning("Amount is require");
        event.preventDefault();
        return;
      }
      if (valueAmount < 0) {
        this.ShowWarning("Invalid Amount");
        event.preventDefault();
        return;
      }
      if (
        valueAmount.indexOf(".") > -1 &&
        this.aSingleRequestPayment.amount.split(".")[1].length > 2
      ) {
        this.ShowWarning("Amount allow with two decimal places");
        event.preventDefault();
        return;
      }
      if (this.aSingleRequestPayment.comment == "") {
        this.ShowWarning("Comment is require");
        event.preventDefault();
        return;
      }
      if (this.aSingleRequestPayment.email != null) {
        if (!this.validEmail(this.aSingleRequestPayment.email)) {
          this.Validity(this.e);
        }
      }
      //this.aSingleRequestPayment.fndx = this.aSinglePatient.pndx;
      this.aSingleRequestPayment.visitId = this.aSinglePatient.visitId;
      this.intDummyComm();
      //const dd = new Date();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.aSingleRequestPayment.patientId = this.aSinglePatient.patientId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.dummyComm.extras = this.dateToLocalString(new Date());
      this.dummyComm.myDate = this.dateToLocalString(new Date());
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SavPayReq";
      const myData = {
        dc: this.dummyComm,
        pr: this.aSingleRequestPayment,
      };
      this.axiosGetData(url, myData, 13);
    },
    paymentReceivedClick(what) {
      const valueAmount = this.aSinglePaymentReceived.amount;

      if (what == "cheque") {
        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.showErrorToast("Cheque Number is require");
          event.preventDefault();
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber.length < 19) {
          this.showErrorToast("Card Number length must be 12");
          return;
        }
        if (this.aSinglePaymentReceived.holderName == 0) {
          this.showErrorToast("Holder name is require");
          return;
        }
        if (this.aSinglePaymentReceived.comment == 0) {
          this.showErrorToast("comment is require");
          return;
        }
        if (valueAmount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
        if (this.aSinglePaymentReceived.amount > this.limitAmount) {
          this.showErrorToast(
            "Amount can not be greater then requested $" + this.limitAmount
          );
          return;
        }
      }
      if (what == "cash") {
        if (this.aSinglePaymentReceived.amount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount == 0) {
          this.showErrorToast("Amount is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
      } else if (what == "credit-card") {
        if (this.aSinglePaymentReceived.cardCVC == "") {
          this.showErrorToast("Card CVC is require");
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.showErrorToast("Card CVC must be of 3 length");
          return;
        }
        if (this.aSinglePaymentReceived.comment == "") {
          this.showErrorToast("Comment is require");
          return;
        }
        if (this.aSinglePaymentReceived.zip == "") {
          this.showErrorToast("Zip is require");
          return;
        }
        if (this.aSinglePaymentReceived.cardCVC.length < 3) {
          this.showErrorToast("Zip must be of 3 length");
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber == "") {
          this.showErrorToast("Card Number is require");
          return;
        }
        if (this.aSinglePaymentReceived.tdNumber.length < 19) {
          this.showErrorToast("Card Number length must be 16");
          return;
        }
        if (this.aSinglePaymentReceived.holderName == "") {
          this.ShowWarning("Holder Name is require");
          return;
        }
        if (valueAmount < 0) {
          this.showErrorToast("Invalid Amount");
          return;
        }
      }
      this.aSinglePaymentReceived.paymentMethod = what;
      this.aSinglePaymentReceived.visitId = this.aSinglePatient.visitId;
      this.aSinglePaymentReceived.patientId = this.aSinglePatient.patientId;
      this.aSinglePaymentReceived.pndx = this.ActivePaymentRequest.pndx;

      this.intDummyComm();
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SavPayRec";
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());

      const myData = { dc: this.dummyComm, pr: this.aSinglePaymentReceived };
      this.btnProColl = true;
      this.axiosGetData(url, myData, 28);
    },
    collectPaymentClick(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      $("#paymentMethod").modal("show");
      this.requestPaymentClick_2(this.aSinglePatient, 0);
    },
    collectPaymentOptionsClick(what) {
      if (what == "credit-card") {
        $("#debit").modal("show");
      } else if (what == "cash") {
        $("#cash").modal("show");
      } else if (what == "cheque") {
        $("#cheque").modal("show");
      }
    },
    updatePatientTypeReasonClick() {
      if (!this.isValidateDate(this.aSinglePatient.dosStr)) {
        this.ShowWarning("Valid Date is required");
        event.preventDefault();
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text:
          "After changing the Visit Type/Reason Old Questionnaire & their Answers will be lost. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Change",
      }).then((result) => {
        if (result.value) {
          this.intDummyComm();
          this.dummyComm.extras = "";
          this.dummyComm.visitId = this.aSinglePatient.visitId;
          //let dd = new Date(this.aSinglePatient.dos);
          //this.aSinglePatient.dosStr =
          //  dd.toISOString().slice(0, 10) + " " + dd.toLocaleTimeString();
          const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdPatTypRea";
          const myData = {
            dc: this.dummyComm,
            patientInfo: this.aSinglePatient,
          };
          this.axiosGetData(url, myData, 10);
        }
      });
    },
    getPatientInfo(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      var date = moment(String(this.aSinglePatient.dosdate)).format(
        "YYYY-MM-DD"
      );
      this.aSinglePatient.dob = date;
      this.intDummyComm();
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId +
        this.UKEY +
        this.aSinglePatient.visitId +
        this.UKEY +
        this.aSinglePatient.patientId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      let url = this.SERVER + "/VNSPRAAPI/Patient/GetSinglePatientData";
      let myData = this.dummyComm;
      this.axiosGetData(url, myData, 33);
    },
    getActiveVisitReasons(id) {
      this.activeVisitReasons = [];
      this.activeVisitReasons = this.visitReasons.filter(
        (f) => f.visitTypeId == id
      );
      // console.log("NEW: ", this.activeVisitReasons);
      // if (this.activeVisitReasons.length > 0)
      //   this.aSinglePatient.visitDetailId =
      //     this.activeVisitReasons[0].visitDetailId;
      // else this.aSinglePatient.visitDetailId = 0;
    },
    editVisitTypeClick(pat) {
      this.visitTypes = [];
      this.visitReasons = [];
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.aSinglePatient.dosStr = this.aSinglePatient.dos.split("T")[0];
      this.intDummyComm();
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.extras = this.aSelectedPatient.patientId;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetTypRea";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 9);
    },
    demoSaveClick() {
      for (var j = 0; j < this.visitDemo.length; j++) {
        // if(this.visitDemo[j].answer == "") {
        //     this.ShowWarning("All Questionnaire Input is require");
        //     return;
        // }
        if (this.visitDemo[j].questTypeName == "Phone Number") {
          if (this.visitDemo[j].answer.length < 12) {
            this.ShowWarning("Phone must be of 10 length");
            return;
          }
        }
        // if (this.visitDemo[j].questTypeName == "Date") {
        //   if (!this.isValidateDate(this.visitDemo[j].answer)) {
        //     this.ShowWarning("Valid Date required");
        //     var d = new Date(this.visitDemo[j].answer);
        //     this.visitDemo[j].answer = moment(d).format('MM/dd/yyyy');
        //     console.log(this.visitDemo[j].answer);
        //     event.preventDefault();
        //     return;
        //   }
        // }
        if (this.visitDemo[j].questTypeName == "Date") {
          var checkDate = this.isValidDateTrue(this.visitDemo[j].answer);
          if (checkDate !== true) {
            this.ShowWarning("Please enter a valid date required");
            var d = new Date(this.visitDemo[j].answer);
            this.visitDemo[j].answer = moment(d).format("MM/dd/yyyy");
            console.log(this.visitDemo[j].answer);
            event.preventDefault();
            return;
          }
        }
        if (this.visitDemo[j].questTypeName == "Email") {
          if (this.visitDemo[j].answer != null) {
            if (!this.validEmail(this.visitDemo[j].answer)) {
              this.Validity(this.e);
            }
          }
        }
      }
      this.intDummyComm();
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.extras = this.aSelectedPatient.patientId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdVisQue";
      const myData = {
        dc: this.dummyComm,
        quests: this.visitDemo,
      };
      this.axiosGetData(url, myData, 8);
      this.successToastUpd();
    },
    questSaveClick() {
      for (var k = 0; k < this.visitQuests.length; k++) {
        // if(this.visitQuests[k].answer == "") {
        //     this.ShowWarning("All Questionnaire Input is require");
        //     return;
        // }
        if (this.visitQuests[k].questTypeName == "Phone Number") {
          if (this.visitQuests[k].answer.length < 12) {
            this.ShowWarning("Phone must be of 10 length");
            return;
          }
        }
        if (this.visitQuests[k].questTypeName == "Date") {
          if (!this.isValidateDate(this.visitQuests[k].answer)) {
            this.ShowWarning("Valid Date of Birth required");
            event.preventDefault();
            return;
          }
        }
        if (this.visitQuests[k].questTypeName == "Email") {
          if (this.visitQuests[k].answer != null) {
            if (!this.validEmail(this.visitQuests[k].answer)) {
              this.Validity(this.e);
            }
          }
        }
      }
      this.intDummyComm();
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.extras = this.aSelectedPatient.patientId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdVisQue";
      const myData = {
        dc: this.dummyComm,
        quests: this.visitQuests,
      };
      this.axiosGetData(url, myData, 8);
      this.successToastUpd();
    },
    questionModalClick(pat) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId;
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetVisQueDat";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 7);
    },
    //222
    stepBackcolor(step) {
      if (step.isStepOverdue == true && step.status !== "2") return "bg-danger";
      else return "";
    },
    stageBackcolor(pat) {
      if (pat.stage.isStageoverdue >= 0) return "bg-danger";
      else return "";
    },

    closeStep(pat, step) {
      const dd = new Date();
      step.stepStartTime = dd;
      this.intDummyComm();
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = "";
      this.dummyComm.emailValue = pat.email;
      this.dummyComm.smsValue = pat.phone;
      this.dummyComm.filter = "";

      this.dummyComm.extras =
        this.dateToSqlServerDateFormat(dd) +
        this.UKEY +
        pat.visitId +
        this.UKEY +
        step.stageId +
        this.UKEY +
        step.stepId;

      const darr = this.currentDateRange.split(" to ");
      let startDate = "";
      let endDate = "";

      if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
      else startDate = new Date(darr[0]);
      endDate = new Date(darr[1]);

      const filter = {
        veinsId: this.mainSearch.searchVeinsId,
        externalId: this.mainSearch.searchExternalId,
        firstName: this.mainSearch.searchFirstName,
        lastName: this.mainSearch.searchLastName,
        phone: this.mainSearch.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        stageId: step.stageId,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sort: this.mainSort,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/CloseStep";
      //console.log(url + "" + myData);
      this.CloseStepAxios(url, myData, step, pat, 6);
    },
    async CloseStepAxios(url, myData, step, pat, oldwhat) {
      console.log(step);
      await axios({
        method: "post",
        url: url,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const obj = res.data;
          if (obj.status === true) {
            this.successToastUpd();
            // this.$nextTick(() => {
            const StepUpdated = obj.data;
            step.pndx = StepUpdated.pndx;
            step.visitId = StepUpdated.visitId;
            (step.stageId = StepUpdated.stageId),
              (step.stepStartTime = StepUpdated.stepStartTime);
            step.stepStartTimeStr = StepUpdated.stepStartTimeStr;
            step.stepName = StepUpdated.name;
            step.stepTimeLimit = StepUpdated.stepTimeLimit;
            step.stepEndTime = StepUpdated.stepEndTime;
            step.status = "2"; //StepUpdated.status;
            step.operatorId = StepUpdated.operatorId;
            step.operatorName = StepUpdated.operatorName;
            // });
          } else if (obj.status === false && obj.error === false) {
            this.errorToastUpd(obj.message);

            this.loadInitWithoutLoad();
            //
          } else {
            this.errorToastUpd(obj.message);
            $("#moveNext-" + pat.patientId + "-" + step.stepId).prop(
              "disabled",
              false
            );
          }
        })
        .catch(function(error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          // this.connection
          //   .invoke("FetchDataAll", this.MyUserId)
          //   .catch(console.error);

          this.callApiForRefreah();

          this.ResetLogoutTime();
          this.calcTimerRoutine();
        });
    },
    moveToNextStep_1(pat, step) {
      if (step.status !== "") return;
      const stage = pat.stageSteps.find((f) => f.stageId == this.watch.stageId);
      // -- Skipped
      // let skipped = [];
      // for (let i = 0; i < stage.steps.length; i++) {
      //   if (stage.steps[i].stepId == step.stepId) break;
      //   if (
      //     stage.steps[i].stepId !== step.stepId &&
      //     stage.steps[i].status == ""
      //   ) {
      //     skipped.push(stage.steps[i].stepId);
      //   }
      // }
      let xx = this.mixinMakeCommString(
        pat.visitId,
        stage.stageId,
        step.stepId,
        this.trackerStageStepStatus[1]
      );
      Swal.fire({
        title: "Are you sure?",
        text:
          "After you start this stage. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.value) {
          const dd = new Date();
          step.stepStartTime = dd;
          this.intDummyComm();
          this.dummyComm.visitId = this.aSinglePatient.visitId;
          this.dummyComm.patientId = this.aSinglePatient.patientId;
          this.dummyComm.stageId = step.stageId;
          this.dummyComm.stepId = step.stepId;
          this.dummyComm.extras =
            dd.toISOString().slice(0, 10) +
            " " +
            dd.toLocaleTimeString() +
            this.UKEY +
            xx;
          const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdateStep";
          const myData = this.dummyComm;
          this.axiosGetData(url, myData, 6).then(() => {});
          this.successToastUpd();
        }
      });
    },
    GetPaymentInfo(rp) {
      this.aSingleRequestPayment = rp;
    },
    evaluateStepDisplay(step) {
      if (
        step.status !== "" &&
        step.status !== this.trackerStageStepStatus[3]
      ) {
        return true;
      } else return false;
    },
    newPatientClick() {
      if (this.aSinglePatient.patientId > 0) {
        this.ShowErrorAutoClose("User already Exit.");
        return;
      }

      this.intDummyComm();
      const stageid = this.stageId;
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.extras = this.aSinglePatient.pndx;
      this.dummyComm.NextStageId = 0;
      this.dummyComm.StageId = this.stageId;
      this.dummyComm.MyDate = new Date().toJSON();
      //********Stageid
      this.dummyComm.modelFrom = 1;
      //this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.dummyComm.filter = "";

      const darr = this.currentDateRange.split(" to ");
      let startDate = "";
      let endDate = "";

      if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
      else startDate = new Date(darr[0]);
      endDate = new Date(darr[1]);

      const filter = {
        veinsId: this.mainSearch.searchVeinsId,
        externalId: this.mainSearch.searchExternalId,
        firstName: this.mainSearch.searchFirstName,
        lastName: this.mainSearch.searchLastName,
        phone: this.mainSearch.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        stageId: this.stageId,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sort: this.mainSort,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/SavNewPat";
      this.axiosGetData(url, myData, 5);
    },
    mergeContinueClick() {
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      if (this.mergedPat.firstName == "") {
        this.ShowWarning("First Name is require");
        event.preventDefault();
        return;
      } else if (this.mergedPat.lastName == "") {
        this.ShowWarning("Last Name is require");
        event.preventDefault();
        return;
      } else if (this.mergedPat.gender == 0) {
        this.ShowWarning("Gender is require");
        event.preventDefault();
        return;
      } else if (!this.isValidateDate(this.mergedPat.dob)) {
        this.ShowWarning("Valid Date of Birth required");
        event.preventDefault();
        return;
      }
      // else if (this.mergedPat.phone == "") {
      //   this.ShowWarning("Phone is require");
      //   event.preventDefault();
      //   return;
      // } else if(this.mergedPat.ssn == ""){
      //   this.ShowWarning("SSN is require");
      //    event.preventDefault();
      //    return;
      //}
      // else if (this.mergedPat.address == "") {
      //   this.ShowWarning("Street Address is require");
      //   event.preventDefault();
      //   return;
      // }
      // else if (this.mergedPat.city == "") {
      //   this.ShowWarning("City is require");
      //   event.preventDefault();
      //   return;
      // }
      // else if (this.mergedPat.State == "") {
      //   this.ShowWarning("State is require");
      //   event.preventDefault();
      //   return;
      // }
      // else if (this.mergedPat.zip == "") {
      //   this.ShowWarning("Zip is require");
      //   event.preventDefault();
      //   return;
      // }
      Swal.fire({
        title: "Are you sure?",
        text:
          "After you merge these profiles. This action cannot be undone. Are you sure you want to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00c292",
        confirmButtonText: "Merge",
      }).then((result) => {
        if (result.value) {
          const dd = new Date();
          this.intDummyComm();
          this.dummyComm.visitId = this.aSinglePatient.visitId;
          this.dummyComm.patientId = this.aSinglePatient.patientId;
          this.dummyComm.MyDate = new Date().toJSON();
          //**$$**
          this.aSinglePatient.firstName = this.mergedPat.firstName;
          this.aSinglePatient.lastName = this.mergedPat.lastName;
          //;
          this.aSinglePatient.dob = this.mergedPat.dob;
          this.aSinglePatient.gender = this.mergedPat.gender;
          this.aSinglePatient.phone = this.mergedPat.phone;
          this.aSinglePatient.email = this.mergedPat.email;
          this.aSinglePatient.ssn = this.mergedPat.ssn;
          this.aSinglePatient.address = this.mergedPat.address;
          this.aSinglePatient.city = this.mergedPat.city;
          this.aSinglePatient.state = this.mergedPat.state;
          this.aSinglePatient.externalId = this.mergedPat.externalId;
          this.aSinglePatient.zip = this.mergedPat.zip;
          this.aSinglePatient.insurance.primaryInsurance = this.mergedPat.primaryIns;
          this.aSinglePatient.insurance.primaryInsuranceNo = this.mergedPat.primaryInsNo;
          this.aSinglePatient.insurance.primaryInsuranceId = this.mergedPat.primaryInsId;
          this.aSinglePatient.insurance.primaryInsuranceGroupId = this.mergedPat.primaryInsGroupId;
          this.aSinglePatient.insurance.secondaryInsurance = this.mergedPat.secondIns;
          this.aSinglePatient.insurance.secondaryInsuranceNo = this.mergedPat.secondInsNo;
          this.aSinglePatient.insurance.secondaryInsuranceId = this.mergedPat.secondInsId;
          this.aSinglePatient.insurance.secondaryInsuranceGroupId = this.mergedPat.secondInsGroupId;
          //**$$**
          this.dummyComm.pageNumber = this.pageNumber;
          this.dummyComm.pageSize = this.pageSize;
          this.dummyComm.extras =
            this.aSelectedPatient.patientId +
            this.UKEY +
            dd.toLocaleDateString() +
            " " +
            dd.toLocaleTimeString();

          const darr = this.currentDateRange.split(" to ");
          let startDate = "";
          let endDate = "";

          if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
          else startDate = new Date(darr[0]);
          endDate = new Date(darr[1]);

          const filter = {
            veinsId: this.mainSearch.searchVeinsId,
            externalId: this.mainSearch.searchExternalId,
            firstName: this.mainSearch.searchFirstName,
            lastName: this.mainSearch.searchLastName,
            phone: this.mainSearch.searchPhone,
            startDate: this.dateToYMD(startDate) + "",
            endDate: this.dateToYMD(endDate) + "",
            stageId: this.stageId,
          };

          const url = this.SERVER + "/VNSPRAAPI/Trackers/MerPat";
          const myData = {
            dc: this.dummyComm,
            pat: this.aSinglePatient,
            ins: this.aSinglePatient.insurance,
            filter: filter,
            sort: this.mainSort,
          };
          this.axiosGetData(url, myData, 5);
        }
      });
    },
    dropdownModalClosed(val) {
      this.showDropDownModal = val;
      this.loadInitWithoutLoad();
      this.CallFetchDataPatients();
    },
    resourceDialogClosed(val) {
      this.showResourceComponentDialog = val;
      this.loadInitWithoutLoad();
    },

    dropDownButtonClick(pat, button) {
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.p_visitId = pat.visitId;
      this.taskPatientId = pat.patientId;
      this.button_Name = button;
      this.showDropDownModal = true;
    },
    checkPatient(pat) {
      this.aSelectedPatient = JSON.parse(JSON.stringify(pat));
      this.dummyComm.extras2 = this.aSinglePatient.dos;
      this.dummyComm.pure = this.aSinglePatient.visitId;

      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.extras =
        this.aSinglePatient.pndx +
        this.UKEY +
        this.aSinglePatient.visitDetailId;
      const url = this.SERVER + "/STDS/StageDisplay/CheckVisitPat";
      this.dummyComm.extras1 = pat.patientId;
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 7000);
    },
    alertModalClick_Suggested() {
      //this.aSelectedPatient = JSON.parse(JSON.stringify(pat));
      //remove spaces
      if (this.aSinglePatient.ptid !== null) {
        this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
      }

      const obj = this.allInsurances.filter(
        (f) => f.patientId == this.aSelectedPatient.patientId
      );
      const obj1 = this.VisitPayCounts.filter(
        (f) => f.patientId == this.aSelectedPatient.patientId
      );
      ////console.log(obj);
      this.aSelectedCounts = {
        VisitCounts: 0,
        PaymentCounts: 0,
        EmailCounts: 0,
        TextCounts: 0,
      };
      this.aSelectedInsurance = {
        primaryInsurance: "",
        primaryInsuranceNo: "",
        primaryInsuranceId: "",
        primaryInsuranceGroupId: "",
        secondaryInsurance: "",
        secondaryInsuranceNo: "",
        secondaryInsuranceId: "",
        secondaryInsuranceGroupId: "",
      };
      if (obj.length > 0) {
        for (let i = 0; i < obj.length; i++) {
          if (obj[i].isPrimary == 1) {
            this.aSelectedInsurance.primaryInsurance = obj[i].insuranceName;
            this.aSelectedInsurance.primaryInsuranceNo = obj[i].insuranceNo;
            this.aSelectedInsurance.primaryInsuranceId = obj[i].insuranceId;
            this.aSelectedInsurance.primaryInsuranceGroupId =
              obj[i].insuranceGroupId;
          } else {
            this.aSelectedInsurance.secondaryInsurance = obj[i].insuranceName;
            this.aSelectedInsurance.secondaryInsuranceNo = obj[i].insuranceNo;
            this.aSelectedInsurance.secondaryInsuranceId = obj[i].insuranceId;
            this.aSelectedInsurance.secondaryInsuranceGroupId =
              obj[i].insuranceGroupId;
          }
        }
      }
      if (obj1.length > 0) {
        for (let j = 0; j < obj1.length; j++) {
          this.aSelectedCounts.VisitCounts = obj1[j].visits;
          this.aSelectedCounts.PaymentCounts = obj1[j].payments;
          this.aSelectedCounts.EmailCounts = obj1[j].emails;
          this.aSelectedCounts.TextCounts = obj1[j].texts;
        }
      }
      // *$$*
      const arr = this.aSelectedPatient.dob.split("/");
      const dd = new Date(arr[2], arr[0] - 1, arr[1]);
      if (this.aSinglePatient.phone == "") {
        this.phone = this.aSelectedPatient.phone;
      } else {
        this.phone = this.aSinglePatient.phone;
      }
      if (this.aSinglePatient.email == "") {
        this.email = this.aSelectedPatient.email;
      } else {
        this.email = this.aSinglePatient.email;
      }
      if (this.aSinglePatient.ssn == "") {
        this.ssn = this.aSelectedPatient.ssn;
      } else {
        this.ssn = this.aSinglePatient.ssn;
      }
      if (this.aSinglePatient.address == "") {
        this.address = this.aSelectedPatient.streetAddress;
      } else {
        this.address = this.aSinglePatient.address;
      }
      if (this.aSinglePatient.city == "") {
        this.city = this.aSelectedPatient.city;
      } else {
        this.city = this.aSinglePatient.city;
      }
      if (this.aSinglePatient.state == "") {
        this.state = this.aSelectedPatient.state;
      } else {
        this.state = this.aSinglePatient.state;
      }
      if (this.aSinglePatient.zip == "") {
        this.zip = this.aSelectedPatient.zip;
      } else {
        this.zip = this.aSinglePatient.zip;
      }
      if (this.aSinglePatient.insurance.primaryInsurance == "") {
        this.primaryInsurance = this.aSelectedInsurance.primaryInsurance;
      } else {
        this.primaryInsurance = this.aSinglePatient.insurance.primaryInsurance;
      }
      if (this.aSinglePatient.insurance.primaryInsuranceNo == "") {
        this.primaryInsuranceNo = this.aSelectedInsurance.primaryInsuranceNo;
      } else {
        this.primaryInsuranceNo = this.aSinglePatient.insurance.primaryInsuranceNo;
      }
      //no longer shown on front end
      if (this.aSinglePatient.insurance.primaryInsuranceId == "") {
        this.primaryInsuranceId = this.aSelectedInsurance.primaryInsuranceId;
      } else {
        this.primaryInsuranceId = this.aSinglePatient.insurance.primaryInsurance;
      }
      //no longer shown on front end

      if (this.aSinglePatient.insurance.primaryInsuranceGroupId == "") {
        this.primaryInsuranceGroupId = this.aSelectedInsurance.primaryInsuranceGroupId;
      } else {
        this.primaryInsuranceGroupId = this.aSinglePatient.insurance.primaryInsuranceGroupId;
      }

      if (this.aSinglePatient.insurance.secondaryInsurance == "") {
        this.secondaryInsurance = this.aSelectedInsurance.secondaryInsurance;
      } else {
        this.secondaryInsurance = this.aSinglePatient.insurance.secondaryInsurance;
      }
      if (this.aSinglePatient.insurance.secondaryInsuranceNo == "") {
        this.secondaryInsuranceNo = this.aSelectedInsurance.secondaryInsuranceNo;
      } else {
        this.secondaryInsuranceNo = this.aSinglePatient.insurance.secondaryInsuranceNo;
      }
      if (this.aSinglePatient.insurance.secondaryInsuranceId == "") {
        this.secondaryInsuranceId = this.aSelectedInsurance.secondaryInsuranceId;
      } else {
        this.secondaryInsuranceId = this.aSinglePatient.insurance.secondaryInsuranceId;
      }

      if (this.aSinglePatient.insurance.secondaryInsuranceGroupId == "") {
        this.secondaryInsuranceGroupId = this.aSelectedInsurance.secondaryInsuranceGroupId;
      } else {
        this.secondaryInsuranceGroupId = this.aSinglePatient.insurance.secondaryInsuranceGroupId;
      }

      if (
        this.aSinglePatient.externalId === "" ||
        this.aSinglePatient.externalId === null
      ) {
        this.externalId = this.aSelectedPatient.externalId;
      } else {
        this.externalId = this.aSinglePatient.externalId;
      }
      this.mergedPat = {
        firstName: this.aSelectedPatient.firstName,
        lastName: this.aSelectedPatient.lastName,
        dob: this.dateToYMD(dd),
        gender: this.aSelectedPatient.gender,
        phone: this.phone,
        email: this.email,
        externalId: this.externalId,
        ssn: this.ssn,
        address: this.address,
        city: this.city,
        state: this.state,
        zip: this.zip,
        primaryIns: this.primaryInsurance,
        primaryInsNo: this.primaryInsuranceNo,
        primaryInsId: this.primaryInsuranceId,
        primaryInsGroupId: this.primaryInsuranceGroupId,
        secondIns: this.secondaryInsurance,
        secondInsNo: this.secondaryInsuranceNo,
        secondInsId: this.secondaryInsuranceId,
        secondInsGroupId: this.secondaryInsuranceGroupId,
      };
      // *$$*
      $("#alertModal").modal("show");
    },
    allPatientsClick() {
      this.filterFirstName = "";
      this.filterLastName = "";
      this.filterPhone = "";
      this.filterDate = "";
      this.filterDDate = "";
      this.filterSearchList();
    },
    filterSearchList_1() {
      this.filterTextSearch = this.userTexts.filter((f) =>
        f.name.toLowerCase().startsWith(this.TextSearch.toLowerCase())
      );
    },
    filterSearchList() {
      try {
        let dd = new Date(this.filterDate);
        let ds = dd.toLocaleDateString();
        if (dd == "Invalid Date" || dd.getFullYear() < 1900) {
          this.suggestedPatients = this.allPatients.filter(
            (f) =>
              f.firstName
                .toLowerCase()
                .startsWith(this.filterFirstName.toLowerCase()) &&
              f.lastName
                .toLowerCase()
                .startsWith(this.filterLastName.toLowerCase()) &&
              f.phone.startsWith(this.filterPhone)
          );
        } else {
          this.suggestedPatients = this.allPatients.filter(
            (f) =>
              f.firstName
                .toLowerCase()
                .startsWith(this.filterFirstName.toLowerCase()) &&
              f.lastName
                .toLowerCase()
                .startsWith(this.filterLastName.toLowerCase()) &&
              f.phone.startsWith(this.filterPhone) &&
              f.dob == ds
          );
        }
      } catch {
        this.suggestedPatients = this.allPatients.filter(
          (f) =>
            f.firstName
              .toLowerCase()
              .startsWith(this.filterFirstName.toLowerCase()) &&
            f.lastName
              .toLowerCase()
              .startsWith(this.filterLastName.toLowerCase()) &&
            f.phone.startsWith(this.filterPhone)
        );
      }
      ////console.log(this.suggestedPatients);
    },
    suggestedClick() {
      const obj = this.aSinglePatient;
      this.suggestedPatients = this.allPatients.filter(
        (f) =>
          f.firstName.toLowerCase() == obj.firstName.toLowerCase() ||
          f.lastName.toLowerCase() == obj.lastName.toLowerCase() ||
          f.ssn == obj.ssn ||
          f.phone == obj.phone ||
          f.email.toLowerCase() == obj.email.toLowerCase() ||
          f.practiceId == obj.practiceId
      );
    },
    assignPhysicianClick(pat) {
      //;
      this.aSinglePatient = JSON.parse(JSON.stringify(pat));
      this.intDummyComm();
      this.dummyComm.filter = "";
      const url = this.SERVER + "/VNSPRAAPI/Practices/GTPHINF1";
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 2);
    },
    async refreshPaginationData(myUrl, myData) {
      let data = "err";
      var loader = this.$loading.show({
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        contentType: "application/json",
        dataType: "json",
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          if (res.data.dc.auditFlag === 1) {
            this.stagesSteps = res.data.stageSteps;
            this.allRawPatients = res.data.patients;
            for (let i = 0; i < res.data.patients.length; i++) {
              this.allRawPatients[i] = res.data.patients[i];
              this.allRawPatients[i].dosStr1 = this.allRawPatients[i].dos.split(
                "T"
              )[0];
              this.allRawPatients[i].dosStr2 = this.allRawPatients[i].dosStr1
                .split("-")[0]
                .substring(2, 4);
              this.allRawPatients[i].dosStr1 = this.allRawPatients[
                i
              ].dosStr1.split("-")[1];
              if (this.allRawPatients[i].dosStr1.length == 1) {
                this.allRawPatients[i].dosStr1 =
                  "0" + this.allRawPatients[i].dosStr1;
              }
            }
            //this.baseStagesSteps = res.data.baseStagesSteps;
            if (this.activeStageNdx < 0) {
              this.stepsInStagesForTable = this.stagesSteps[0].steps;
            } else
              this.stepsInStagesForTable = this.stagesSteps[
                this.activeStageNdx
              ].steps;
            this.stepRes = res.data.stepRes;
            this.stageRes = res.data.stageRes;
          }
          loader.hide();
        })
        .catch(function(err) {
          loader.hide();
        })
        .finally(() => {
          loader.hide();
        });
      return data;
    }, // axiosGetData

    async stageClick(ndx, val) {
      if (this.activeStageNdx == ndx) return;
      try {
        this.dummyComm.StageId = this.stagesSteps[ndx].stageId;
        this.stageId = this.dummyComm.StageId;
        this.pageNumber = 1;
        this.aSingleStage = JSON.parse(JSON.stringify(this.stagesSteps[ndx]));
        this.stepsInStagesForTable = this.stagesSteps[ndx].steps;
        this.activeStageNdx = ndx;

        await this.applyFilterAPI(this.stageId, 1, true);

        // if (val == -1 || val == 6) {
        //   this.pageChange(1);
        // }
      } catch {
        this.calcTimerRoutine();
      } finally {
        this.calcTimerRoutine();
      }
    },

    filterPatientByStage() {
      this.searchMainList();
      const obj = this.allFilterPatients;
      this.allFilterPatients = [];
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].currentStage == this.aSingleStage.stageId)
          this.allFilterPatients.push(obj[i]);
      }
    },
    updatePatientResources(vid = 0) {
      //console.log(vid);
      let pndx = [];
      for (let i = 0; i < this.allFilterPatients.length; i++) {
        let ress = [];
        let obj = this.stepRes.filter(
          (f) =>
            f.visitId == this.allFilterPatients[i].visitId && f.stepId == -1
          //&& f.isActive == 1
        );
        //-- steps
        const ob = this.allFilterPatients[i].stageSteps;
        for (let j = 0; j < ob.length; j++) {
          if (
            ob[j].status == 1 ||
            ob[j].status == this.trackerStageStepStatus[1]
          ) {
            ////console.log(ob[j].status, this.trackerStageStepStatus[1]);
            for (let k = 0; k < ob[j].steps.length; k++) {
              if (
                ob[j].steps[k].status == 1 ||
                ob[j].steps[k].status == this.trackerStageStepStatus[1]
              ) {
                ////console.log("INNER: ", ob[j].steps[k].status, this.trackerStageStepStatus[1]);
                let obj1 = this.stepRes.filter(
                  (f) =>
                    f.stageId == this.aSingleStage.stageId &&
                    f.stepId == ob[j].steps[k].stepId &&
                    f.visitId == this.allFilterPatients[i].visitId
                  //&& f.isActive == 1
                );
                //console.log("allFilterPatients[i].stageSteps ", ob);
                for (let m = 0; m < obj1.length; m++) {
                  ress.push(obj1[m].resourceStrId);
                  //if (this.allFilterPatients[i].visitId == vid)
                  pndx.push(obj1[m].pndx);
                }
              }
            }
          }
        }
        //--
        let xx = "";
        if (ress.length > 0) {
          for (let jj = 0; jj < ress.length; jj++) xx += ress[jj] + ", ";
          xx = xx.substring(0, xx.length - 2);
        }
        this.allFilterPatients[i].resStr = xx;
      }
      return pndx;
    },
    clearPhysicianAssignment() {
      for (let i = 0; i < this.phyList.length; i++) {
        this.phyList[i].isAlloted = 0;
        const dd = new Date(this.phyList[i].dob);
        this.phyList[i].dob = dd.toLocaleDateString();
      }
    },
    phyAssignedClick(phy) {
      //this.clearPhysicianAssignment();
      this.aSinglePatient.allotedPhysicianId = phy.userId;
      phy.isAlloted = 1;
      let xx = this.allRawPatients.find(
        (f) => f.pndx == this.aSinglePatient.pndx
      );
      xx.allotedPhysicianId = phy.userId;
      xx.isAlloted = 1;
      const dd = new Date();
      const stageid = this.stageId;
      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.filter = "";
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.NextStageId = 0;
      this.dummyComm.StageId = this.stageId;
      //********Stageid
      this.dummyComm.modelFrom = 1;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.dummyComm.filter = "";

      const darr = this.currentDateRange.split(" to ");
      let startDate = "";
      let endDate = "";

      if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
      else startDate = new Date(darr[0]);
      endDate = new Date(darr[1]);

      const filter = {
        veinsId: this.mainSearch.searchVeinsId,
        externalId: this.mainSearch.searchExternalId,
        firstName: this.mainSearch.searchFirstName,
        lastName: this.mainSearch.searchLastName,
        phone: this.mainSearch.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        stageId: this.stageId,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sort: this.mainSort,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/UpdPhy1";
      this.dummyComm.extras = this.mixinMakeCommString(
        this.aSinglePatient.pndx,
        phy.userId,
        dd.toLocaleDateString() + " " + dd.toLocaleTimeString()
      );
      // const myData = { dc: this.dummyComm, patientInfo: this.aSinglePatient };
      this.axiosGetData(url, myData, 3);
    },
    mergeModalClick1() {
      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumberSuggest;
      this.dummyComm.pageSize = this.pageSizeSuggest;
      this.dummyComm.filter = "";

      //+++555+++/
      let startDate = "";
      let endDate = "";

      startDate = new Date(1805, 1, 1);
      endDate = new Date();

      const filter = {
        veinsId: this.suggested.searchVeinsId,
        externalId: this.suggested.searchExternalId,
        firstName: this.suggested.searchFirstName,
        lastName: this.suggested.searchLastName,
        phone: this.suggested.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        Dob: this.suggested.Dob,
        stageId: 0,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sortColumn: this.sortColumnSuggest,
        sortColumnOption: this.sortColumnOptionSuggest,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPatsPageSuggest";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      this.axiosGetData(url, myData, 404);
    },
    mergeModalClick(pat) {
      $("#mappingClick").click();
      if (typeof pat !== "undefined") {
        this.aSinglePatient = JSON.parse(JSON.stringify(pat));
        if (this.aSinglePatient.ptid !== null) {
          this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
        }
      }

      this.intDummyComm();
      this.dummyComm.extras = "nFilter";
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumberSuggest;
      this.dummyComm.pageSize = this.pageSizeSuggest;
      this.dummyComm.filter = "";

      //+++555+++/
      let startDate = "";
      let endDate = "";

      startDate = new Date(1805, 1, 1);
      endDate = new Date();

      const filter = {
        veinsId: this.suggested.searchVeinsId,
        externalId: "",
        firstName: this.aSinglePatient.firstName,
        lastName: this.aSinglePatient.lastName,
        phone: this.aSinglePatient.phone,
        email: this.aSinglePatient.email,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        Dob: this.dateToYMD(this.aSinglePatient.dob),
        stageId: 0,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sortColumn: this.sortColumnSuggest,
        sortColumnOption: this.sortColumnOptionSuggest,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPatsPageSuggest";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      this.axiosGetData(url, myData, 4);
    },
    mergeModalClickReload() {
      if (this.aSinglePatient.ptid !== null) {
        this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
      }

      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumberSuggest;
      this.dummyComm.pageSize = this.pageSizeSuggest;
      this.dummyComm.filter = "";

      //+++555+++/
      let startDate = "";
      let endDate = "";

      startDate = new Date(1805, 1, 1);
      endDate = new Date();

      const filter = {
        veinsId: this.suggested.searchVeinsId,
        externalId: "",
        firstName: this.aSinglePatient.firstName,
        lastName: this.aSinglePatient.lastName,
        phone: this.aSinglePatient.phone,
        email: this.aSinglePatient.email,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        Dob: this.dateToYMD(this.aSinglePatient.dob),
        stageId: 0,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sortColumn: this.sortColumnSuggest,
        sortColumnOption: this.sortColumnOptionSuggest,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPatsPageSuggest";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      this.axiosGetData(url, myData, 400);
    },
    mergeModalClickReloadChange() {
      if (this.aSinglePatient.ptid !== null) {
        this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
      }

      this.intDummyComm();
      this.dummyComm.extras = "nFilter";
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumberSuggest;
      this.dummyComm.pageSize = this.pageSizeSuggest;
      this.dummyComm.filter = "";

      //+++555+++/
      let startDate = "";
      let endDate = "";
      var filter = {};
      startDate = new Date(1805, 1, 1);
      endDate = new Date();

      if (
        this.suggested.searchVeinsId == "" &&
        this.suggested.searchExternalId == "" &&
        this.suggested.searchFirstName == "" &&
        this.suggested.searchLastName == "" &&
        this.suggested.searchPhone == "" &&
        this.suggested.Dob == ""
      ) {
        filter = {
          veinsId: this.suggested.searchVeinsId,
          externalId: "",
          firstName: this.aSinglePatient.firstName,
          lastName: this.aSinglePatient.lastName,
          phone: this.aSinglePatient.phone,
          email: this.aSinglePatient.email,
          startDate: this.dateToYMD(startDate) + "",
          endDate: this.dateToYMD(endDate) + "",
          Dob: this.dateToYMD(this.aSinglePatient.dob),
          stageId: 0,
        };
      } else {
        filter = {
          veinsId: this.suggested.searchVeinsId,
          externalId: this.suggested.searchExternalId,
          firstName: this.suggested.searchFirstName,
          lastName: this.suggested.searchLastName,
          phone: this.suggested.searchPhone,
          startDate: this.dateToYMD(startDate) + "",
          endDate: this.dateToYMD(endDate) + "",
          Dob: this.suggested.Dob,
          stageId: 0,
        };
      }

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sortColumn: this.sortColumnSuggest,
        sortColumnOption: this.sortColumnOptionSuggest,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPatsPageSuggest";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      this.axiosGetData(url, myData, 400);
    },
    mergeModalClickReload1() {
      if (this.aSinglePatient.ptid !== null) {
        this.aSinglePatient.ptid = this.aSinglePatient.ptid.replace(/ /g, "");
      }

      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.pageNumber = this.pageNumberSuggest1;
      this.dummyComm.pageSize = this.pageSizeSuggest1;
      this.dummyComm.filter = "";

      //+++555+++/
      let startDate = "";
      let endDate = "";

      startDate = new Date(1805, 1, 1);
      endDate = new Date();

      const filter = {
        veinsId: this.suggested1.searchVeinsId,
        externalId: this.suggested1.searchExternalId,
        firstName: this.suggested1.searchFirstName,
        lastName: this.suggested1.searchLastName,
        phone: this.suggested1.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        Dob: this.suggested1.Dob,
        stageId: 0,
      };

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sortColumn: this.sortColumnSuggest1,
        sortColumnOption: this.sortColumnOptionSuggest1,
      };

      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetAllPatsPage";
      //this.aSingleInsurance.fndx = this.aSinglePatient.pndx;
      this.axiosGetData(url, myData, 500);
    },
    searchMainList_1() {
      if (this.startDate_1 != "" && this.endDate_1 != "") {
        this.allFilterPatients_1 = this.requestPaymentsList.filter(
          (f) =>
            +new Date(f.dos) >= +new Date(this.startDate_1) &&
            +new Date(f.dos) <= +new Date(this.endDate_1)
        );
      }
    },
    searchMainList_2() {
      if (this.startDate_2 != "" && this.endDate_2 != "") {
        this.allFilterVisitHist = this.visitHistory.filter(
          (f) =>
            +new Date(f.dosLocalTime) >= +new Date(this.startDate_2) &&
            +new Date(f.dosLocalTime) <= +new Date(this.endDate_2)
        );
      }
    },
    searchMainList_3() {
      if (this.startDate_3 != "" && this.endDate_3 != "") {
        this.allFilterPayHist = this.paymentHistory;
      }
    },
    async searchMainList() {
      //+++***999
      try {
        this.allFilterPatients = JSON.parse(
          JSON.stringify(this.allRawPatients)
        );
      } catch {
        /**/
      }
    },
    isNumber(evt) {
      //console.log("this a pressing");
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    clearSearchFields() {
      this.mainSearch = {
        searchVeinsId: "",
        searchExternalId: "",
        searchFirstName: "",
        searchLastName: "",
        searchPhone: "",
      };
      var dateFormat = this.dateToMDY(new Date());
      this.initDate_1 = ""; //dateFormat + " - " + dateFormat;
    },
    // ~~calcTimer
    calcTimerRoutine() {
      for (let i = 0; i < this.allFilterPatients.length; i++) {
        const pat = this.allFilterPatients[i];
        let found = false;
        for (let j = 0; j < pat.stageSteps.length; j++) {
          if (pat.stageSteps[j].status !== "") {
            found = true;
            break;
          }
        }
        pat.stage.alert = pat.stageAlert;
        found = true;
        if (found) {
          pat.stage.isStageActive = true;
          for (let j = 0; j < pat.stageSteps.length; j++) {
            if (pat.stageSteps[j].stageId == this.aSingleStage.stageId) {
              for (let k = 0; k < pat.stageSteps[j].steps.length; k++) {
                let obj = pat.stageSteps[j].steps[k];
                if (obj.status !== "2") {
                  // if is active
                  const startTime = new Date(this.allFilterPatients[i].timeIn);

                  const dd = new Date(new Date().toISOString().slice(0, -1)); //
                  const blah = moment
                    .utc(dd)
                    .add(this.TimeHours(this.timeZoneId), "hours")
                    .toDate();
                  const diff = Math.abs(blah - startTime);
                  const xx = Math.floor(diff / 1000 / 60);
                  let seconds = Math.floor(diff / 1000);
                  let minutes = Math.floor(seconds / 60);
                  let hours = Math.floor(minutes / 60);
                  let days = Math.floor(hours / 24);
                  hours = hours - days * 24;
                  minutes = minutes - days * 24 * 60 - hours * 60;
                  seconds = seconds % 60;
                  obj.timeElapsed =
                    ("00" + days).slice(-2) +
                    ":" +
                    ("00" + hours).slice(-2) +
                    ":" +
                    ("00" + minutes).slice(-2) +
                    ":" +
                    ("00" + seconds).slice(-2);
                  if (xx >= obj.stepTimeLimit && obj.stepTimeLimit > 0) {
                    obj.isStepOverdue = true;
                    obj.stepOverdueTime = xx;
                  } else obj.isStepOverdue = false;
                }
              }
            }
          }
        } else {
          pat.stage.isStageActive = false;
          const dos = new Date(pat.timeIn);
          const dd = new Date();
          const diff = Math.abs(dd - dos);
          pat.stage.isStageoverdue = Math.floor(diff / 1000 / 60);
        }
      }
      for (let i = 0; i < this.allFilterPatients.length; i++) {
        // stage overdue
        const pat1 = this.allFilterPatients[i];
        const pat = pat1.stage;
        pat.isStageoverdue = false;
        const xyz = new Date(this.allFilterPatients[i].timeIn);
        if (xyz && pat.alert > 0) {
          // the most importtant thing in the universe
          const dd = new Date(new Date().toISOString().slice(0, -1)); //
          const blah = moment
            .utc(dd)
            .add(this.TimeHours(this.timeZoneId), "hours")
            .toDate();
          // the most importtant thing in the universe
          const start = this.dateAdd(
            new Date(xyz),
            "m",
            this.allFilterPatients[i].stage.alert
          );
          const diff = blah - start;
          if (diff > 0)
            this.allFilterPatients[i].stage.isStageoverdue = Math.floor(
              diff / 1000 / 60
            );
          else {
            let asd = Math.floor(diff / 1000 / 60);
            this.allFilterPatients[i].stage.isStageoverdue = Math.floor(
              diff / 1000 / 60
            );
          }
        }
      }
      this.updatePatientResources();
    },
    TimeHours(timeZoneId) {
      if (timeZoneId == 1) {
        return -10;
      } else if (timeZoneId == 2) {
        return -9;
      } else if (timeZoneId == 3) {
        return -8;
      } else if (timeZoneId == 4) {
        return -7;
      } else if (timeZoneId == 5) {
        return -6;
      } else if (timeZoneId == 6) {
        return -5;
      } else if (timeZoneId == 7) {
        return -4;
      } else if (timeZoneId == 8) {
        return -5;
      } else if (timeZoneId == 9) {
        return -6;
      } else if (timeZoneId == 10) {
        return -7;
      } else if (timeZoneId == 11) {
        return -8;
      } else if (timeZoneId == 12) {
        return -9;
      }
    },
    addHours(date, hours) {
      date.setHours(date.getHours() + hours);
      return date;
    },
    async AddTriggerStepLog(pat, step) {
      this.intDummyComm();
      this.dummyComm.patientId = pat.patientId;
      this.dummyComm.visitId = pat.visitId;
      this.dummyComm.stageId = pat.currentStage;
      this.dummyComm.stepId = step.stepId;
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Stages/PostTriggerSteplog",
        data: this.dummyComm,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const response = res.data;
          console.log(response);
        })
        .catch(function(error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
        });
    },
    async AddTriggerStageLog(pat) {
      this.intDummyComm();
      this.dummyComm.patientId = pat.patientId;
      this.dummyComm.visitId = pat.visitId;
      this.dummyComm.stageId = pat.currentStage;
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Stages/PostTriggerStagelog",
        data: this.dummyComm,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const response = res.data;
        })
        .catch(function(error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
        });
    },
    getActiveBaseStage() {
      const sid = this.aSingleStage.stageId;
      const bs = this.baseStagesSteps;

      for (let i = 0; i < bs.stages.length; i++) {
        if (bs.stages[i].stageDetail.stage.stageId == sid) {
          return bs.stages[i].stageDetail;
        }
      }
    },

    getStageAlertText() {
      const as = this.getActiveBaseStage();
      let str = `${as.stage.alertDays} day, ${as.stage.alertHours} hour, ${as.stage.alertMins} min`;
      return str;
    },

    getStageAlertResources() {
      const as = this.getActiveBaseStage();
      return as.res;
    },

    getStageAlertEmail() {
      const as = this.getActiveBaseStage();
      return as.email;
    },

    getStageAlertSMS() {
      const as = this.getActiveBaseStage();
      return as.sms;
    },

    showCommentLine(ndx) {
      const xx = this.commentsList.length - 1;
      if (ndx < xx) return true;
      else return false;
    },
    commentLeftClick() {
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetCommentsList";
      this.intDummyComm();
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.axiosGetData(url, this.dummyComm, 25);
    },
    leaveCommentSaveClick() {
      if (this.commentText.length < 1) {
        this.ShowWarning("Comment is require");
        event.preventDefault();
        return;
      }
      const url = this.SERVER + "/VNSPRAAPI/Trackers/SaveComment";
      this.intDummyComm();
      this.dummyComm.extras = this.commentText;
      this.dummyComm.visitId = this.aSinglePatient.visitId;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
      this.axiosGetData(url, this.dummyComm, 26);
    },
    collectPaymentButtonClass(rp) {
      if (rp.status == "4") return "btn btn-success";
      else return "btn btn-danger";
    },
    collectPaymentButtonClassDropDown(rp) {
      if (rp.status == "4")
        return "btn btn-success btn btn-success dropdown-toggle dropdown-toggle-split";
      else
        return "btn btn-success  btn btn-danger dropdown-toggle dropdown-toggle-split";
    },
    requestPaymentClick_1() {
      this.intDummyComm();
      this.dummyComm.extras = this.aSinglePatient.patientId;
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetPayRequestPatient";
      const myData = this.dummyComm;
      this.axiosGetData(url, myData, 29);
    },
    GetAuditLog() {
      this.intDummyComm();
      this.dummyComm.myDate = "";
      //this.dummyComm.Extras = "";
      const url = this.SERVER + "/VNSPRAAPI/actionlog/GetInitData1";
      this.axiosGetData(url, this.dummyComm, 30);
    },
    //***loadinit */
    loadInit() {
      const darr = this.currentDateRange.split(" to ");
      let startDate = "";
      let endDate = "";

      if (darr[0] == "From start") startDate = new Date(1805, 1, 1);
      else startDate = new Date(darr[0]);
      endDate = new Date(darr[1]);

      const filter = {
        veinsId: this.mainSearch.searchVeinsId,
        externalId: this.mainSearch.searchExternalId,
        firstName: this.mainSearch.searchFirstName,
        lastName: this.mainSearch.searchLastName,
        phone: this.mainSearch.searchPhone,
        startDate: this.dateToYMD(startDate) + "",
        endDate: this.dateToYMD(endDate) + "",
        stageId: 0,
      };

      this.intDummyComm();
      this.dummyComm.extras = "";
      this.dummyComm.pageNumber = 1;
      this.dummyComm.pageSize = this.pageSize;

      const myData = {
        dc: this.dummyComm,
        filter: filter,
        sort: this.mainSort,
      };

      this.dummyComm.pageNumber = this.pageNumber;
      this.dummyComm.pageSize = this.pageSize;
      //const url = this.SERVER + "/VNSPRAAPI/Trackers/StageDispInitData_1";
      const url =
        this.SERVER + "/VNSPRAAPI/Trackers/GetStageDisplayFilteredPatients";
      this.axiosGetData(url, myData, 1);
      this.StartLogoutTime();
    },

    loadInitWithoutLoad() {
      this.applyFilterAPI(this.aSingleStage.stageId, 666);

      this.StartLogoutTime();
    },
    getIcon(id) {
      if (id == 100) return "assets/images/actions/comment.png";
      else if (id == 50) return "assets/images/actions/edit.png";
      else if (id == 51) return "assets/images/actions/sent.png";
      else if (id == 300) return "assets/images/actions/credit-card.png";
      else if (id == 302) return "assets/images/actions/stethoscope.png";
      else if (id == 303) return "assets/images/actions/stethoscope.png";
      else if (id == 201) return "assets/images/actions/mapping.png";
      else if (id == 301) return "assets/images/actions/cash-money.png";
      else if (id == 400) return "assets/images/actions/steps1.png";
      else if (id == 304) return "assets/images/actions/patient.png";
    },
    getBlankSingleInsurance() {
      const xx = {
        pndx: 0,
        visitId: 0,
        patientId: 0,
        primaryInsurance: "",
        primaryInsuranceNo: "",
        primaryInsuranceGroupId: "",
        primaryInsuranceId: "",
        secondaryInsurance: "",
        secondaryInsuranceNo: "",
        secondaryInsuranceGroupId: "",
        secondaryInsuranceId: "",
      };
      return xx;
    },
    //-------------------- Common Methods
    getPatStageSteps(pat) {
      if (this.activeStageNdx < 0) return pat.stageSteps[0].steps;
      else {
        return pat.stageSteps[this.activeStageNdx].steps;
      }
    },

    async axiosGetData(myUrl, myData, what) {
      //usmanbutt
      if (
        what == 66 ||
        what == 200 ||
        what === 1001 ||
        what == 6 ||
        what == 277 ||
        what === 666
      ) {
        //console.log("ok");
      } else {
        var loader = this.$loading.show({
          color: "#03a9f3",
        });
      }
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          //999** if everything goes well -- we will get data
          if (what === 1 || what === 27 || what === 1001) {
            // get data loadinit no need to
            $("#v-" + myData.dc.visitId + "").prop("disabled", false);
            this.stagesSteps = res.data.stageSteps;
            if (res.data.dc.auditFlag === 1) {
              res.data.patients.map(function(value, key) {
                if (value.appointmentTime != null) {
                  var newAppointmentTimeValue = new Date(
                    value.appointmentTime
                  ).toLocaleString("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                    hour12: false,
                  });
                  value.appointmentTime = newAppointmentTimeValue;
                  value.isUpdateAppointmentTime = newAppointmentTimeValue;
                } else {
                  value.isUpdateAppointmentTime = value.appointmentTime;
                }
              });

              this.myData = res.data;

              this.totalPages = res.data.dc.totalPages;
              this.totalRows = res.data.dc.totalRow;
              this.allRawPatients = res.data.patients;

              //remove ptId space
              for (let i = 0; i < res.data.patients.length; i++) {
                if (this.allRawPatients[i].ptid !== null) {
                  this.allRawPatients[i].ptid = res.data.patients[
                    i
                  ].ptid.replace(/ /g, "");
                }
              }
              for (let j = 0; j < res.data.patients.length; j++) {
                var val1 = this.getAge(res.data.patients[j].dobStr);
                this.allRawPatients[j].Year = val1.years;
                this.allRawPatients[j].Month = val1.months;
                this.allRawPatients[j].Days = val1.days;
              }

              this.baseStagesSteps = res.data.baseStagesSteps;
              if (this.activeStageNdx < 0) {
                this.stepsInStagesForTable = this.stagesSteps[0].steps;
              }
              this.stepRes = res.data.stepRes;
              this.stageRes = res.data.stageRes;
              this.operators = res.data.operators;
              this.timeZoneId = res.data.timeZoneId;
            }
          } else if (what == 900) {
            //get payment requests

            loader.hide();
            this.successToastUpd();
            this.filteredPaymentRequests = res.data.list;
          } else if (what === 277) {
            $("#v-" + myData.visitId + "").prop("disabled", false);
            if (res.data.dc.auditFlag === 1) {
              res.data.patients.map(function(value, key) {
                if (value.appointmentTime != null) {
                  var newAppointmentTimeValue = new Date(
                    value.appointmentTime
                  ).toLocaleString("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                    hour12: false,
                  });
                  value.appointmentTime = newAppointmentTimeValue;
                  value.isUpdateAppointmentTime = newAppointmentTimeValue;
                } else {
                  value.isUpdateAppointmentTime = value.appointmentTime;
                }
              });

              this.myData = res.data;
              this.allRawPatients = res.data.patients;
              for (let i = 0; i < res.data.patients.length; i++) {
                this.allRawPatients[i] = res.data.patients[i];
                this.allRawPatients[i].dosStr1 = this.allRawPatients[
                  i
                ].dos.split("T")[0];
                this.allRawPatients[i].dosStr2 = this.allRawPatients[i].dosStr1
                  .split("-")[0]
                  .substring(2, 4);
                this.allRawPatients[i].dosStr1 = this.allRawPatients[
                  i
                ].dosStr1.split("-")[1];
                if (this.allRawPatients[i].dosStr1.length == 1) {
                  this.allRawPatients[i].dosStr1 =
                    "0" + this.allRawPatients[i].dosStr1;
                }
              }
              this.stagesSteps = res.data.stageSteps;
            }
          } else if (what === 3) {
            //get
            if (res.data.dc.auditFlag === 1) {
              this.allRawPatients = res.data.patients;
              this.stagesSteps = res.data.stageSteps;
              //this.stageRes = res.data.stageRes;
              this.stepRes = res.data.stepRes;
              this.successToastUpd();
              $("#assignPhysician").modal("hide");
            }
          } else if (what === 2) {
            if (res.data.dc.auditFlag === 1) {
              this.phyList = res.data.ph;
              for (var j = 0; j < this.phyList.length; j++) {
                var val = this.phyList[j].dob.split(" ");
                this.phyList[j].dob = val[0];
              }
              //this.clearPhysicianAssignment();
              $("#assignPhysician").modal("show");
            } else {
              this.errorToast(res.data.dc.auditFlagVal);
            }
          } else if (what === 4) {
            loader.hide();
            this.totalRowsSuggest = res.data.dc.totalRow;
            this.totalPagesSuggest = res.data.dc.totalPages;
            this.VisitPayCounts = res.data.stats;
            this.allPatients = res.data.patient;
            this.allInsurances = res.data.insurance;
            for (let i = 0; i < this.allPatients.length; i++) {
              const dd = new Date(this.allPatients[i].dob);
              this.allPatients[i].dob = dd.toLocaleDateString();
              //this.allPatients[i].dobd = dd;
            }
            const obj = this.aSinglePatient;
            this.suggestedPatients = this.allPatients;
            for (var i = 0; i < this.suggestedPatients.length; i++) {
              if (this.suggestedPatients[i].ptid !== null) {
                this.suggestedPatients[i].ptid = this.suggestedPatients[
                  i
                ].ptid.replace(/ /g, "");
              }
            }
            $("#mergeModal").modal("show");
          } else if (what === 404) {
            loader.hide();
            this.totalRowsSuggest = res.data.dc.totalRow;
            this.totalPagesSuggest = res.data.dc.totalPages;
            this.VisitPayCounts = res.data.stats;
            this.allPatients = res.data.patient;
            this.allInsurances = res.data.insurance;
            for (let m = 0; m < this.allPatients.length; m++) {
              const dd = new Date(this.allPatients[m].dob);
              this.allPatients[m].dob = dd.toLocaleDateString();
              //this.allPatients[i].dobd = dd;
            }
            const obj = this.aSinglePatient;
            this.suggestedPatients = this.allPatients;
            for (var l = 0; l < this.suggestedPatients.length; l++) {
              if (this.suggestedPatients[l].ptid !== null) {
                this.suggestedPatients[l].ptid = this.suggestedPatients[
                  i
                ].ptid.replace(/ /g, "");
              }
            }
          } else if (what == 8000) {
            for (let k = 0; k < res.data.list.length; k++) {
              //dos
              res.data.list[k].dos = res.data.list[k].dos.split("T");
              res.data.list[k].dos = res.data.list[k].dos[0];
              //dare req
              res.data.list[k].billDate = res.data.list[k].billDate.split("T");
              res.data.list[k].billDate = res.data.list[k].billDate[0];
            }
            this.filteredPaymentRequests = res.data.list;
            this.totalRowsPays = res.data.dc.totalRow;
            this.totalPagesPays = res.data.dc.totalPages;
          } else if (what === 400) {
            //this.loader.hide();
            this.totalRowsSuggest = res.data.dc.totalRow;
            this.totalPagesSuggest = res.data.dc.totalPages;
            this.VisitPayCounts = res.data.stats;
            this.allPatients = res.data.patient;
            this.allInsurances = res.data.insurance;
            for (let k = 0; k < this.allPatients.length; k++) {
              const dd = new Date(this.allPatients[k].dob);
              this.allPatients[k].dob = dd.toLocaleDateString();
            }
            const obj = this.aSinglePatient;
            this.suggestedPatients = this.allPatients;
            for (let j = 0; j < this.suggestedPatients.length; j++) {
              if (this.suggestedPatients[j].ptid !== null) {
                this.suggestedPatients[j].ptid = this.suggestedPatients[
                  j
                ].ptid.replace(/ /g, "");
              }
            }
          } else if (what === 500) {
            //this.loader.hide();
            this.totalRowsSuggest1 = res.data.dc.totalRow;
            this.totalPagesSuggest1 = res.data.dc.totalPages;
            this.VisitPayCounts = res.data.stats;
            this.allPatients = res.data.patient;
            this.allInsurances = res.data.insurance;
            for (let k = 0; k < this.allPatients.length; k++) {
              const dd = new Date(this.allPatients[k].dob);
              this.allPatients[k].dob = dd.toLocaleDateString();
            }
            const obj = this.aSinglePatient;
            this.suggestedPatients1 = this.allPatients;
            for (let j = 0; j < this.suggestedPatients1.length; j++) {
              if (this.suggestedPatients1[j].ptid !== null) {
                this.suggestedPatients1[j].ptid = this.suggestedPatients1[
                  j
                ].ptid.replace(/ /g, "");
              }
            }
          } else if (what === 5) {
            // Merge patient Data
            try {
              if (res.data.dc.auditFlag > 0) {
                res.data.patients.map(function(value, key) {
                  if (value.appointmentTime != null) {
                    var newAppointmentTimeValue = new Date(
                      value.appointmentTime
                    ).toLocaleString("en-US", {
                      hour: "numeric",
                      minute: "numeric",
                      hour12: false,
                    });
                    value.appointmentTime = newAppointmentTimeValue;
                    value.isUpdateAppointmentTime = newAppointmentTimeValue;
                  } else {
                    value.isUpdateAppointmentTime = value.appointmentTime;
                  }
                });

                this.allRawPatients = res.data.patients;
                for (let i = 0; i < res.data.patients.length; i++) {
                  this.allRawPatients[i] = res.data.patients[i];
                  this.allRawPatients[i].dosStr1 = this.allRawPatients[
                    i
                  ].dos.split("T")[0];
                  this.allRawPatients[i].dosStr2 = this.allRawPatients[
                    i
                  ].dosStr1
                    .split("-")[0]
                    .substring(2, 4);
                  this.allRawPatients[i].dosStr1 = this.allRawPatients[
                    i
                  ].dosStr1.split("-")[1];
                  if (this.allRawPatients[i].dosStr1.length == 1) {
                    this.allRawPatients[i].dosStr1 =
                      "0" + this.allRawPatients[i].dosStr1;
                  }
                }

                for (let j = 0; j < res.data.patients.length; j++) {
                  var Dob = this.getAge(res.data.patients[j].dobStr);
                  this.allRawPatients[j].Year = Dob.years;
                  this.allRawPatients[j].Month = Dob.months;
                  this.allRawPatients[j].Days = Dob.days;
                }
                this.stagesSteps = res.data.stageSteps;
                //this.allInsurances = res.data.insurance;
                this.stepRes = res.data.stepRes;
                $("#mergeModal").modal("hide");
                $("#alertModal").modal("hide");
                this.successToastUpd();
              } else this.errorToast(res.data.dc.auditFlagVal);
            } catch {
              //this.calcTimerRoutine();
            }
          } else if (what === 5002) {
            try {
              if (res.data.dc.auditFlag > 0) {
                //
                // if(res.data.dc.externalIdCount > 0){
                //   this.errorToast("External Id must be Unique");
                // }
                this.allRawPatients = res.data.patients;
                for (let i = 0; i < res.data.patients.length; i++) {
                  this.allRawPatients[i] = res.data.patients[i];
                  this.allRawPatients[i].dosStr1 = this.allRawPatients[
                    i
                  ].dos.split("T")[0];
                  this.allRawPatients[i].dosStr2 = this.allRawPatients[
                    i
                  ].dosStr1
                    .split("-")[0]
                    .substring(2, 4);
                  this.allRawPatients[i].dosStr1 = this.allRawPatients[
                    i
                  ].dosStr1.split("-")[1];
                  if (this.allRawPatients[i].dosStr1.length == 1) {
                    this.allRawPatients[i].dosStr1 =
                      "0" + this.allRawPatients[i].dosStr1;
                  }
                }
                this.stagesSteps = res.data.stageSteps;
                //this.allInsurances = res.data.insurance;
                this.stepRes = res.data.stepRes;
                $("#mergeModal").modal("hide");
                $("#alertModal").modal("hide");
                this.successToastUpd();
              } else this.errorToast(res.data.dc.auditFlagVal);
            } catch {
              //this.calcTimerRoutine();
            }
          } else if (what === 6) {
            this.successToastUpd();
            //this.applyFilterAPI(this.stageId, 1, false);
            const stepData = res.data;
            if (stepData.status === true) {
              var patient = this.allFilterPatients.find(
                (x) => x.visitId === stepData.visitId
              );
              var patientStage = patient.stageSteps.find(
                (x) => x.stageId === stepData.stageId
              );
              var patientStep = patientStage.steps.find(
                (x) => x.stepId === stepData.stepId
              );
            }
          } else if (what === 666) {
            if (res.data.dc.auditFlag === 1) {
              this.stagesSteps = res.data.stageSteps;

              res.data.patients.map(function(value, key) {
                if (value.appointmentTime != null) {
                  var newAppointmentTimeValue = new Date(
                    value.appointmentTime
                  ).toLocaleString("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                    hour12: false,
                  });
                  value.appointmentTime = newAppointmentTimeValue;
                  value.isUpdateAppointmentTime = newAppointmentTimeValue;
                } else {
                  value.isUpdateAppointmentTime = value.appointmentTime;
                }
              });

              this.myData = res.data;
              this.totalPages = res.data.dc.totalPages;
              this.totalRows = res.data.dc.totalRow;
              this.allRawPatients = res.data.patients;
              //remove ptId space
              for (let i = 0; i < res.data.patients.length; i++) {
                if (this.allRawPatients[i].ptid !== null) {
                  this.allRawPatients[i].ptid = res.data.patients[
                    i
                  ].ptid.replace(/ /g, "");
                }
              }
              for (let j = 0; j < res.data.patients.length; j++) {
                var val11 = this.getAge(res.data.patients[j].dobStr);
                this.allRawPatients[j].Year = val11.years;
                this.allRawPatients[j].Month = val11.months;
                this.allRawPatients[j].Days = val11.days;
              }
              this.baseStagesSteps = res.data.baseStagesSteps;
              if (this.activeStageNdx < 0) {
                this.stepsInStagesForTable = this.stagesSteps[0].steps;
              }

              this.stepRes = res.data.stepRes;
              this.stageRes = res.data.stageRes;
              this.operators = res.data.operators;
              //this.gFillUserInfo(this.operators);
            }
          } else if (what == 9000) {
            $("#reminder").modal("hide");
            this.successToastUpd("Reminder sent successfully.");
          } else if (what == 9001) {
            this.filteredPaymentRequests = res.data.list;
            this.successToastUpd("Deleted successfully.");
          } else if (what == 9002) {
            this.successToastUpd("Receipt sent successfully.");
          } else if (what == 9003) {
            this.successToastUpd("Amount Refunded Successful!");
            for (let k = 0; k < res.data.list.length; k++) {
              //dos
              res.data.list[k].dos = res.data.list[k].dos.split("T");
              res.data.list[k].dos = res.data.list[k].dos[0];
              //dare req
              res.data.list[k].billDate = res.data.list[k].billDate.split("T");
              res.data.list[k].billDate = res.data.list[k].billDate[0];
            }
            this.refundAmount = "";
            this.filteredPaymentRequests = res.data.list;
            this.totalRowsPays = res.dc.totalRow;
            this.totalPagesPays = res.dc.totalPages;
          } else if (what === 66) {
            this.successToastUpd();
            let str = [];
            for (var k = 0; k < res.data.dc.resourceValue.length; k++) {
              if (res.data.dc.resourceValue[k] !== "") {
                str.push(res.data.dc.resourceValue[k]);
              }
            }
            if (str.length > 0) {
              var str1 = [...new Set(str)];
              this.ShowWarning(str1);
            }
            this.allRawPatients = res.data.patients;
            for (let i = 0; i < res.data.patients.length; i++) {
              this.allRawPatients[i] = res.data.patients[i];
              this.allRawPatients[i].dosStr1 = this.allRawPatients[i].dos.split(
                "T"
              )[0];
              this.allRawPatients[i].dosStr2 = this.allRawPatients[i].dosStr1
                .split("-")[0]
                .substring(2, 4);
              this.allRawPatients[i].dosStr1 = this.allRawPatients[
                i
              ].dosStr1.split("-")[1];
              if (this.allRawPatients[i].dosStr1.length == 1) {
                this.allRawPatients[i].dosStr1 =
                  "0" + this.allRawPatients[i].dosStr1;
              }
            }
            this.stagesSteps = res.data.stageSteps;
            //this.stageRes = res.data.stageRes;
            this.stepRes = res.data.stepRes;
            //this.$router.go(0);
            this.updatePatientResources();
          } else if (what === 200) {
            this.successToastUpd();
            this.allRawPatients = res.data.patients;
            for (let i = 0; i < res.data.patients.length; i++) {
              this.allRawPatients[i] = res.data.patients[i];
              this.allRawPatients[i].dosStr1 = this.allRawPatients[i].dos.split(
                "T"
              )[0];
              this.allRawPatients[i].dosStr2 = this.allRawPatients[i].dosStr1
                .split("-")[0]
                .substring(2, 4);
              this.allRawPatients[i].dosStr1 = this.allRawPatients[
                i
              ].dosStr1.split("-")[1];
              if (this.allRawPatients[i].dosStr1.length == 1) {
                this.allRawPatients[i].dosStr1 =
                  "0" + this.allRawPatients[i].dosStr1;
              }
            }
            this.stagesSteps = res.data.stageSteps;
            //this.stageRes = res.data.stageRes;
            this.stepRes = res.data.stepRes;
            //this.$router.go(0);
            this.updatePatientResources();
          } else if (what === 7000) {
            if (res.data.extras === "0") {
              this.alertModalClick_Suggested();
            } else {
              this.showMergeSwal();
            }
          } else if (what === 67) {
            this.allRawPatients = res.data.patients;
            for (let i = 0; i < res.data.patients.length; i++) {
              this.allRawPatients[i] = res.data.patients[i];
              this.allRawPatients[i].dosStr1 = this.allRawPatients[i].dos.split(
                "T"
              )[0];
              this.allRawPatients[i].dosStr2 = this.allRawPatients[i].dosStr1
                .split("-")[0]
                .substring(2, 4);
              this.allRawPatients[i].dosStr1 = this.allRawPatients[
                i
              ].dosStr1.split("-")[1];
              if (this.allRawPatients[i].dosStr1.length == 1) {
                this.allRawPatients[i].dosStr1 =
                  "0" + this.allRawPatients[i].dosStr1;
              }
            }
            this.stagesSteps = res.data.stageSteps;
            //this.stageRes = res.data.stageRes;
            this.stepRes = res.data.stepRes;
            //this.$router.go(0);
            this.updatePatientResources();
          } else if (what === 7) {
            if (res.data.dc.auditFlag === 1) {
              //console.log("QUESTS: ", res.data);
              this.visitQuests = res.data.quests;
              $("#questionModal").modal("show");
            } else {
              this.ShowError(res.data.dc.auditFlagVal);
            }
          } else if (what === 8) {
            if (res.data.auditFlag === 1) {
              $("#questionModal").modal("hide");
            }
          } else if (what === 9) {
            if (res.data.dc.auditFlag === 1) {
              this.visitTypes = res.data.types;
              this.visitReasons = res.data.reasons;
              this.getActiveVisitReasons(this.aSinglePatient.visitTypeId);
              $("#editVisit").modal("show");
            } else {
              this.errorToast("No Visit Type(s) found ...");
            }
          } else if (what === 10) {
            $("#editVisit").modal("hide");
            if (res.data.dc.auditFlag === 1) {
              res.data.patients.map(function(value, key) {
                if (value.appointmentTime != null) {
                  var newAppointmentTimeValue = new Date(
                    value.appointmentTime
                  ).toLocaleString("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                    hour12: false,
                  });
                  value.appointmentTime = newAppointmentTimeValue;
                  value.isUpdateAppointmentTime = newAppointmentTimeValue;
                } else {
                  value.isUpdateAppointmentTime = value.appointmentTime;
                }
              });

              //this.myData = res.data;
              this.allRawPatients = res.data.patients;
              for (let i = 0; i < res.data.patients.length; i++) {
                this.allRawPatients[i] = res.data.patients[i];
                this.allRawPatients[i].dosStr1 = this.allRawPatients[
                  i
                ].dos.split("T")[0];
                this.allRawPatients[i].dosStr2 = this.allRawPatients[i].dosStr1
                  .split("-")[0]
                  .substring(2, 4);
                this.allRawPatients[i].dosStr1 = this.allRawPatients[
                  i
                ].dosStr1.split("-")[1];
                if (this.allRawPatients[i].dosStr1.length == 1) {
                  this.allRawPatients[i].dosStr1 =
                    "0" + this.allRawPatients[i].dosStr1;
                }
              }
              this.stagesSteps = res.data.stageSteps;
              //this.stageRes = res.data.stageRes;
              this.stepRes = res.data.stepRes;
              this.successToastUpd();
            } else {
              this.errorToast(res.data.dc.auditFlagVal);
            }
          } else if (what === 2002) {
            this.Email11 = "";
            this.Phone11 = "";
            this.displayRem2 = false;
            loader.hide();
            this.successToastUpd();
          } else if (what === 12) {
            this.patients = res.data.patients;
            this.stageSteps = res.data.stageSteps.stages;
            this.insurance = res.data.insurance;
            this.successToastUpd();
            $("#debit").modal("hide");
            $("#cash").modal("hide");
            $("#cheque").modal("hide");
          } else if (what === 13) {
            if (res.data.dc.auditFlag > 0) {
              this.requestPaymentsList = res.data.lpr;
              this.patients = res.data.main.patients;
              this.stageSteps = res.data.main.stageSteps.stages;
              this.insurance = res.data.main.insurance;
              $("#paymentRequest").modal("hide");
              this.successToastUpd();
            } else {
              this.errorToastUpd(res.data.dc.auditFlagVal);
            }
          } else if (what === 14) {
            this.$nextTick(() => {
              $("#newptModal").on("shown.bs.modal", function(e) {
                console.log($(document).off("focusin.modal"));
              });
            });
            if (res.data.dc.auditFlag === 1) {
              this.insurance = res.data.insurances;
              if (this.insurance == null) {
                this.aSinglePatient.insurance = this.insurance = {
                  primaryInsurance: "",
                  primaryInsuranceId: "",
                  primaryInsuranceNo: "",
                  primaryInsuranceGroupId: "",
                  secondaryInsurance: "",
                  secondaryInsuranceId: "",
                  secondaryInsuranceNo: "",
                  secondaryInsuranceGroupId: "",
                };
              } else {
                this.aSinglePatient.insurance = this.insurance;
              }

              //visitDemo Date
              this.visitDemo = res.data.quests.quests;
              for (let k = 0; k < this.visitDemo.length; k++) {
                if (this.visitDemo[k].questTypeName == "Date") {
                  if (
                    this.visitDemo[k].answer !== "" ||
                    this.visitDemo[k].answer == "Invalid date"
                  ) {
                    this.visitDemo[k].answer = moment(
                      String(this.visitDemo[k].answer)
                    ).format("YYYY-MM-DD");
                  }
                }
              }

              this.visitQuests = res.data.quests.quests;
              this.requestPaymentsList = res.data.lpr;
              this.paymentHistory = res.data.paymentHistory;

              this.userTexts = res.data.userTexts;
              this.filterTextSearch = this.userTexts;
              this.emailHistory = res.data.emailHistory;
              this.PhpageNumber = res.data.dc.pageNumberP;
              this.PhpageSize = res.data.dc.pageSizeP;
              this.PhtotalPages = res.data.dc.totalPagesP;
              this.PhtotalRows = res.data.dc.totalRowP;
              this.visitHistory = res.data.visitHistory;
              var date = moment(String(this.aSinglePatient.dob)).format(
                "YYYY-MM-DD"
              );

              this.aSinglePatient.dob = date;
              this.aSinglePatient.externalId = res.data.patient.externalId;
              if (res.data.insurances != null) {
                this.insurance = res.data.insurances;
                if (this.insurance.secondaryInsuranceId == "")
                  this.insurance.secondaryInsuranceId = "Secondary Id";
                if (this.insurance.primaryInsuranceId == "")
                  this.insurance.primaryInsuranceId = "Insurance Id";
                //console.log((this.insurance = res.data.insurances));
              }
              this.users = res.data.users;
              $("#newptModal").modal("show");
            } else {
              this.errorToast(res.data.dc.auditFlagVal);
            }
          } else if (what === 15) {
            this.emailTempsList = res.data;
            this.emailTempsList.splice(0, 0, {
              name: "Compose",
              emailTemplateId: 0,
              emailText: "",
            });
          } else if (what === 16) {
            if (res.data.dc.auditFlag === 1) {
              this.allRawPatients = res.data.patients;
              for (let i = 0; i < res.data.patients.length; i++) {
                this.allRawPatients[i] = res.data.patients[i];
                this.allRawPatients[i].dosStr1 = this.allRawPatients[
                  i
                ].dos.split("T")[0];
                this.allRawPatients[i].dosStr2 = this.allRawPatients[i].dosStr1
                  .split("-")[0]
                  .substring(2, 4);
                this.allRawPatients[i].dosStr1 = this.allRawPatients[
                  i
                ].dosStr1.split("-")[1];
                if (this.allRawPatients[i].dosStr1.length == 1) {
                  this.allRawPatients[i].dosStr1 =
                    "0" + this.allRawPatients[i].dosStr1;
                }
              }
              this.stagesSteps = res.data.stageSteps;
              //this.stageRes = res.data.stageRes;
              this.stepRes = res.data.stepRes;
              this.successToastUpd();
            }
          } else if (what === 17) {
            this.successToastUpd();
            if (res.data.dc.auditFlag === 1) {
              this.successToastUpd();
            } else {
              this.errorToastUpd(res.data.dc.auditFlag);
            }
          } else if (what === 18) {
            if (res.data.dc.auditFlag > 0) {
              this.requestPaymentsList = res.data.lpr;
              let xx = this.requestPaymentsList.find(
                (f) => f.visitId == this.aSinglePatient.visitId
              );
              if (typeof xx !== "undefined")
                this.aSingleRequestPayment = JSON.parse(JSON.stringify(xx));
              else {
                this.aSingleRequestPayment = {
                  billNo: 0,
                  amount: 0,
                  email: "",
                  phone: "",
                  comment: "",
                };
                this.getPaymentEmailPhone(this.PvisitId);
              }
              $("#paymentRequest").modal("show");
            }
          } else if (what === 188) {
            if (res.data.dc.auditFlag > 0) {
              this.requestPaymentsList = res.data.lpr;
              let xx = this.requestPaymentsList.find(
                (f) => f.visitId == this.aSinglePatient.visitId
              );
              if (typeof xx !== "undefined")
                this.aSingleRequestPayment = JSON.parse(JSON.stringify(xx));
              else {
                this.aSingleRequestPayment = {
                  billNo: 0,
                  amount: 0,
                  email: "",
                  phone: "",
                  comment: "",
                };
              }
            }
          } else if (what === 189) {
            this.aSingleRequestPayment.email = res.data.email;
            this.aSingleRequestPayment.phone = res.data.phone;
          } else if (what === 19) {
            if (res.data.auditFlag > 0) this.successToastUpd();
            //this.ShowSuccessAutoClose(res.data.auditFlagVal);
            else this.errorToast(res.data.auditFlagVal);
          } else if (what === 20) {
            this.patResSumm = res.data.rs;
            if (this.patResSumm.length > 0) {
              $("#resourceidmodal").modal();
              $("#resourceidmodal").show();
            }
          } else if (what === 21) {
            this.patResSumm = res.data.rs;
            if (this.patResSumm.length > 0) {
              $("#resourceidmodal").modal("show");
            }
            this.successToastUpd();
          } else if (what === 22) {
            this.smsTempsList = res.data;
            this.smsTempsList.splice(0, 0, {
              name: "Compose",
              emailTemplateId: 0,
              emailText: "",
            });
            $("#sendText").modal("show");
          } else if (what === 23) {
            this.successToastUpd();
            if (res.data.auditFlag === 1) {
              this.aSingleEmail = {
                name: "",
                emailSubject: "",
                emailText: "",
              };
              this.getPatientInfo(this.aSinglePatient);
              $("#sendText").modal("hide");
            } else {
              this.errorToast(res.data.auditFlagVal);
            }
          } else if (what === 24) {
            this.aSingleUserSmsHist = res.data;
            this.textHistorySerch = this.aSingleUserSmsHist;
            this.textHistory = [];
            for (let j = 0; j < this.textHistorySerch.length; j++) {
              this.textHistory.push(this.textHistorySerch[j]);
            }
            console.log(this.textHistory);
          } else if (what === 25) {
            this.commentsList = res.data;
            $("#CommentModal").modal("show");
            $("#comment-text").focus();
          } else if (what === 26) {
            this.commentsList = res.data;
            this.commentText = "";
            this.successToastUpd();
          } else if (what === 28) {
            this.successToastUpd();
            this.aSinglePaymentReceived.tdNumber = "";
            this.aSinglePaymentReceived.holderName = "";
            this.aSinglePaymentReceived.cardCVC = "";
            this.aSinglePaymentReceived.ExpirationDate = "";
            this.aSinglePaymentReceived.comment = "";
            this.aSinglePaymentReceived.zip = "";
            this.aSinglePaymentReceived.amount = "";
            for (let k = 0; k < res.data.list.length; k++) {
              //dos
              res.data.list[k].dos = res.data.list[k].dos.split("T");
              res.data.list[k].dos = res.data.list[k].dos[0];
              //dare req
              res.data.list[k].billDate = res.data.list[k].billDate.split("T");
              res.data.list[k].billDate = res.data.list[k].billDate[0];
            }
            loader.hide();
            this.filteredPaymentRequests = res.data.list;
            this.totalRowsPays = res.dc.totalRow;
            this.totalPagesPays = res.dc.totalPages;
            this.btnProColl = false;
            this.cardModal = false;
            this.chequeModal = false;
            this.cashModal = false;
          } else if (what === 29) {
            if (res.data.dc.auditFlag > 0) {
              this.requestPaymentsList = res.data.lpr;
            }
          } else if (what === 30) {
            this.auditData = res.data.visitHist;
          } else if (what === 31) {
            if (res.data.dc.auditFlag === 1) {
              this.successToastUpd();

              res.data.patients.map(function(value, key) {
                if (value.appointmentTime != null) {
                  var newAppointmentTimeValue = new Date(
                    value.appointmentTime
                  ).toLocaleString("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                    hour12: false,
                  });
                  value.appointmentTime = newAppointmentTimeValue;
                  value.isUpdateAppointmentTime = newAppointmentTimeValue;
                } else {
                  value.isUpdateAppointmentTime = value.appointmentTime;
                }
              });

              this.myData = res.data;
              this.allRawPatients = res.data.patients;
              for (let i = 0; i < res.data.patients.length; i++) {
                this.allRawPatients[i] = res.data.patients[i];
                this.allRawPatients[i].dosStr1 = this.allRawPatients[
                  i
                ].dos.split("T")[0];
                this.allRawPatients[i].dosStr2 = this.allRawPatients[i].dosStr1
                  .split("-")[0]
                  .substring(2, 4);
                this.allRawPatients[i].dosStr1 = this.allRawPatients[
                  i
                ].dosStr1.split("-")[1];
                if (this.allRawPatients[i].dosStr1.length == 1) {
                  this.allRawPatients[i].dosStr1 =
                    "0" + this.allRawPatients[i].dosStr1;
                }
              }
              this.stagesSteps = res.data.stageSteps;
              //this.stageRes = res.data.stageRes;
              this.stepRes = res.data.stepRes;
              this.operators = res.data.operators;
              this.gFillUserInfo(this.operators);
              //this.loadInit();
            }
          } else if (what === 32) {
            if (res.data.auditFlag > 0) {
              this.successToastUpd("Text message sent");
              this.getPatientInfo(this.aSinglePatient);
              this.chatSms = "";
              this.aSingleSms = {
                name: "",
                smsText: "",
              };
            } else {
              this.ShowErrorAutoClose("Unable to Send Text");
            }
          } else if (what === 33) {
            if (res.data.dc.auditFlag === 1) {
              this.visitDemo = res.data.quests.quests;
              this.requestPaymentsList = res.data.lpr;
              this.allRawPatients = res.data.patients;
              for (let i = 0; i < res.data.patients.length; i++) {
                this.allRawPatients[i] = res.data.patients[i];
                this.allRawPatients[i].dosStr1 = this.allRawPatients[
                  i
                ].dos.split("T")[0];
                this.allRawPatients[i].dosStr2 = this.allRawPatients[i].dosStr1
                  .split("-")[0]
                  .substring(2, 4);
                this.allRawPatients[i].dosStr1 = this.allRawPatients[
                  i
                ].dosStr1.split("-")[1];
                if (this.allRawPatients[i].dosStr1.length == 1) {
                  this.allRawPatients[i].dosStr1 =
                    "0" + this.allRawPatients[i].dosStr1;
                }
              }
              this.visitHistory = res.data.visitHistory;
              this.paymentHistory = res.data.paymentHistory;
              this.emailHistory = res.data.emailHistory;
              //this.textHistory = res.data.textHistory;
              this.userTexts = res.data.userTexts;
              this.filterTextSearch = this.userTexts;
              this.users = res.data.users;
              if (res.data.insurances != null) {
                this.aSinglePatient.insurance = res.data.insurances;
                if (this.aSinglePatient.insurance.secondaryInsuranceId == "")
                  this.aSinglePatient.insurance.secondaryInsuranceId =
                    "Secondary Id";
                if (this.aSinglePatient.insurance.primaryInsuranceId == "")
                  this.aSinglePatient.insurance.primaryInsuranceId =
                    "Insurance Id";
              }
            } else {
              this.errorToast(res.data.dc.auditFlagVal);
            }
          }
          this.groupingLoader = 0;
        })
        .catch(function(error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          if (
            what == 6 ||
            what == 27 ||
            what == 3 ||
            what == 5 ||
            what == 31 ||
            what == 5002 ||
            what == 17 ||
            what == 9003 ||
            what == 9000 ||
            what == 28
          ) {
            this.CallFetchDataPatients();
          }
          loader.hide();
          this.ResetLogoutTime();
          this.calcTimerRoutine();
        });
    },

    PhOrderBy(column) {
      // if(this.firstTime==true)
      // {
      //   this.firstTime = false;
      //   return;
      // }
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.dosStr < b.dosStr ? 1 : b.dosStr < a.dosStr ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.dosStr > b.dosStr ? 1 : b.dosStr > a.dosStr ? -1 : 0
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.amount < b.amount ? 1 : b.amount < a.amount ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.amount > b.amount ? 1 : b.amount > a.amount ? -1 : 0
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.paymentMethodStr < b.paymentMethodStr
              ? 1
              : b.paymentMethodStr < a.paymentMethodStr
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.paymentMethodStr > b.paymentMethodStr
              ? 1
              : b.paymentMethodStr > a.paymentMethodStr
              ? -1
              : 0
          );
        }
      }
      if (column == 4) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.comment < b.comment ? 1 : b.comment < a.comment ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.comment > b.comment ? 1 : b.comment > a.comment ? -1 : 0
          );
        }
      }
      if (column == 5) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.statusStr < b.statusStr ? 1 : b.statusStr < a.statusStr ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.statusStr > b.statusStr ? 1 : b.statusStr > a.statusStr ? -1 : 0
          );
        }
      }
      if (column == 6) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.paymentDateStr < b.paymentDateStr
              ? 1
              : b.paymentDateStr < a.paymentDateStr
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.paymentDateStr > b.paymentDateStr
              ? 1
              : b.paymentDateStr > a.paymentDateStr
              ? -1
              : 0
          );
        }
      }
      if (column == 7) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.collectedByName < b.collectedByName
              ? 1
              : b.collectedByName < a.collectedByName
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.paymentHistory = this.paymentHistory.sort((a, b) =>
            a.collectedByName > b.collectedByName
              ? 1
              : b.collectedByName > a.collectedByName
              ? -1
              : 0
          );
        }
      }
      this.ResetLogoutTime();
    },
    VhOrderBy(column) {
      if (this.firstTime == true) {
        this.firstTime = false;
        return;
      }
      this.orderByCol = column;
      if (column == 1) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.visitTypeName < b.visitTypeName
              ? 1
              : b.visitTypeName < a.visitTypeName
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.visitTypeName > b.visitTypeName
              ? 1
              : b.visitTypeName > a.visitTypeName
              ? -1
              : 0
          );
        }
      }
      if (column == 2) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.reason < b.reason ? 1 : b.reason < a.reason ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.reason > b.reason ? 1 : b.reason > a.reason ? -1 : 0
          );
        }
      }
      if (column == 3) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.dosLocalDateStr < b.dosLocalDateStr
              ? 1
              : b.dosLocalDateStr < a.dosLocalDateStr
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.dosLocalDateStr > b.dosLocalDateStr
              ? 1
              : b.dosLocalDateStr > a.dosLocalDateStr
              ? -1
              : 0
          );
        }
      }
      if (column == 4) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.dosLocalTimeStr < b.dosLocalTimeStr
              ? 1
              : b.dosLocalTimeStr < a.dosLocalTimeStr
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.practices.sort((a, b) =>
            a.dosLocalTimeStr > b.dosLocalTimeStr
              ? 1
              : b.dosLocalTimeStr > a.dosLocalTimeStr
              ? -1
              : 0
          );
        }
      }
      if (column == 5) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.stageName < b.stageName ? 1 : b.stageName < a.stageName ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.stageName > b.stageName ? 1 : b.stageName > a.stageName ? -1 : 0
          );
        }
      }
      if (column == 6) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.stepName < b.stepName ? 1 : b.stepName < a.stepName ? -1 : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.stepName > b.stepName ? 1 : b.stepName > a.stepName ? -1 : 0
          );
        }
      }
      if (column == 7) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.physicianName < b.physicianName
              ? 1
              : b.physicianName < a.physicianName
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.physicianName > b.physicianName
              ? 1
              : b.physicianName > a.physicianName
              ? -1
              : 0
          );
        }
      }
      if (column == 8) {
        if (this.asc_desc == "asc") {
          this.asc_desc = "desc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.commentText < b.commentText
              ? 1
              : b.commentText < a.commentText
              ? -1
              : 0
          );
        } else {
          this.asc_desc = "asc";
          this.visitHistory = this.visitHistory.sort((a, b) =>
            a.commentText > b.commentText
              ? 1
              : b.commentText > a.commentText
              ? -1
              : 0
          );
        }
      }
      this.ResetLogoutTime();
    },
    removeFromHub() {
      const str = localStorage.OSversion;
      const arr = str.split(this.UKEY);
      var UserId = arr[0] * 1;
      //const mu = this.$StageDisplayHub;
      this.$StageDisplayHub.AddToStageDisplay(UserId);
    },
    UpdatePatient() {
      const str = localStorage.OSversion;
      const arr = str.split(this.UKEY);
      var UserId = arr[0] * 1;
      //const mu = this.$StageDisplayHub;
      this.$StageDisplayHub.UpdateStageDisplay(UserId);
    },
    UpdateDisplayData(res) {
      alert("All done");
      console.log(res);
    },
    // axiosGetData
    selectBase(obj) {
      if (obj != -1) {
        this.showStepData = this.baseStagesSteps.stages[
          this.activeStageNdx
        ].steps;
        this.showCapturedData = this.baseStagesSteps.stages[
          this.activeStageNdx
        ].stageDetail.res.filter((e) => e.isCaptured == true);
        this.showStepData.forEach((e) => {
          var data2 = e.res.filter((e) => e.isCaptured == true);
          // data2.forEach((e) => {
          //   this.showCapturedData.push(e);
          // });
          console.log(data2);
        });
      }
    },
    DisablePatButtons(
      VisitId //would disable the rwo in table
    ) {
      $("#v" + VisitId + " :button").attr("disabled", true);
      $("#v" + VisitId + " :a").attr("disabled", true);
    },
    EnablePatButtons(VisitId) {
      $("#v" + VisitId + " :button").attr("disabled", false);
      $("#v" + VisitId + " :a").attr("disabled", false);
    },
    PhpageChange(obj) {
      if (obj == "Next") {
        if (this.PhpageNumber < this.PhtotalPages) {
          this.PhpageNumber += 1;
        }
      } else if (obj == "Previous" && this.PhpageNumber != 1) {
        this.PhpageNumber -= 1;
      } else {
        this.PhpageNumber = obj;
      }

      if (this.showPagesMax1 / 2 < this.PhpageNumber) {
        this.showPagesMin1 = this.PhpageNumber - 4;
        this.showPagesMax1 = this.PhpageNumber + 4;
      } else if (this.showPagesMin1 / 2 < this.PhpageNumber) {
        this.showPagesMin1 = this.PhpageNumber - 4;
        this.showPagesMax1 = this.PhpageNumber + 4;
        if (this.showPagesMax1 < 5) {
          this.showPagesMax1 = 5;
        }
      } else {
        this.showPagesMin1 = 1;
        this.showPagesMax1 = 5;
      }

      this.fetchPayHistory();
    },
    fetchPayHistory() {
      this.intDummyComm();
      if (!this.aSinglePatient) {
        return;
      }
      this.dummyComm.pageNumber = 1;
      this.dummyComm.pageSize = this.pageSize;
      //this.dummyComm.extras = this.initDate_2;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.loader = this.$loading.show({
        color: "#03a9f3",
      });
      const url = this.SERVER + "/VNSPRAAPI/Patient/GetPaymentHistoryTable";
      this.getaxiosPayHistory(url, this.dummyComm);
    },
    async getaxiosPayHistory(url, myData) {
      await axios({
        method: "post",
        url: url,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          const response = res.data;
          if (response.dc.auditFlag == 1) {
            this.paymentHistory = res.data.paymentHistory;
            this.PhpageNumber = response.pageNumberP;
            this.PhtotalPages = response.totalPagesP;
            this.PhtotalRows = response.totalRowsP;
          } else {
            this.showErrorToast("unable to fetch data");
            console.log("unable to fetch data");
          }
        })
        .catch(function(error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          this.loader.hide();
          this.ResetLogoutTime();
          this.calcTimerRoutine();
        });
    },
    VhpageChange(obj) {
      if (obj == "Next") {
        if (this.VhpageNumber < this.VhtotalPages) {
          this.VhpageNumber += 1;
        }
      } else if (obj == "Previous" && this.VhpageNumber != 1) {
        this.VhpageNumber -= 1;
      } else {
        this.VhpageNumber = obj;
      }

      if (this.showPagesMax1 / 2 < this.VhpageNumber) {
        this.showPagesMin1 = this.VhpageNumber - 4;
        this.showPagesMax1 = this.VhpageNumber + 4;
      } else if (this.showPagesMin1 / 2 < this.VhpageNumber) {
        this.showPagesMin1 = this.VhpageNumber - 4;
        this.showPagesMax1 = this.VhpageNumber + 4;
        if (this.showPagesMax1 < 5) {
          this.showPagesMax1 = 5;
        }
      } else {
        this.showPagesMin1 = 1;
        this.showPagesMax1 = 5;
      }

      this.fetchVisitistory();
    },
    fetchVisitistory() {
      this.intDummyComm();

      if (!this.aSinglePatient) {
        return;
      }
      this.dummyComm.pageNumber = 1;
      this.dummyComm.pageSize = this.pageSize;
      this.dummyComm.extras = this.initDate_2;
      this.dummyComm.patientId = this.aSinglePatient.patientId;
      this.loader = this.$loading.show({
        color: "#03a9f3",
      });
      const url = this.SERVER + "/VNSPRAAPI/Trackers/GetVisitHistory";
      this.getaxiosHistory(url, this.dummyComm);
    },
    async getaxiosHistory(url, myData) {
      await axios({
        method: "post",
        url: url,
        data: myData,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          console.log(res);
          const response = res.data;
          if (response.dc.auditFlag == 1) {
            this.visitHistory = res.data.patientVisitHistories;
            this.VhpageNumber = response.vhPageNumber;

            this.VhtotalPages = response.vhTotalPages;
            this.VhtotalRows = response.vhTotalRows;
          } else {
            this.showErrorToast("unable to fetch data");
            console.log("unable to fetch data");
          }
        })
        .catch(function(error) {
          if (error.response) {
            // alert("-> " + error.response.data);
            // alert("-> " + error.response.status);
            // alert("-> " + error.response.headers);
          } else if (error.request) {
            //alert("No response " + error.request);
          } else {
            //alert("Error", error.message);
          }
        })
        .finally(() => {
          this.loader.hide();
          this.ResetLogoutTime();
          this.calcTimerRoutine();
        });
    },

    async assignTask(task) {
      console.log(task);
      $("#taskidmodal").modal("show");
      this.intDummyComm();
      const myUrl = this.SERVER + "/VNSPRAAPI/Tasks/AssignTask";
      this.dummyComm.visitId = this.taskVisitId;
      task.visitId = this.taskVisitId;
      const obj = {
        DC: this.dummyComm,
        CheckedinPatientTasks: task,
      };
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: myUrl,
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          this.loader.hide();
          const response = res.data;
          if (response.auditFlag === 1) {
            this.successToastUpd();
            this.getTaskClick(this.taskVisitId);
          } else {
            this.errorToast(response.auditFlagVal);
          }
        })
        .catch(function(error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          } else {
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          if (this.loader !== undefined) this.loader.hide();
        });
    },
    async markAsCompletedTask(task) {
      console.log(task);
      $("#taskidmodal").modal("show");
      this.intDummyComm();
      const myUrl = this.SERVER + "/VNSPRAAPI/Tasks/MarkAsCompletedTask";
      this.dummyComm.visitId = this.taskVisitId;
      task.visitId = this.taskVisitId;
      const obj = {
        DC: this.dummyComm,
        CheckedinPatientTasks: task,
      };
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      await axios({
        method: "post",
        url: myUrl,
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          this.loader.hide();
          const response = res.data;
          if (response.auditFlag === 1) {
            this.successToastUpd();
            this.getTaskClick(this.taskVisitId);
          } else {
            this.errorToast(response.auditFlagVal);
          }
        })
        .catch(function(error) {
          if (error.response) {
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            alert("No response " + error.request);
          } else {
            alert("Error", error.message);
          }
        })
        .finally(() => {
          this.ResetLogoutTime();
          if (this.loader !== undefined) this.loader.hide();
        });
      return false;
    },
    hideTableTask() {
      this.taskTable = false;
    },
    async getTaskClick(visitId, pat) {
      this.showPatientTasksTable = true;

      this.taskVisitId = visitId;
      this.taskPatientId = pat.patientId;

      this.$nextTick(() => {
        $("#taskidmodal").modal("show");
      });
      //$("#taskidmodal").modal('show');

      this.$nextTick(() => {
        this.$refs.taskTableRef.getTableData();
      });
      this.intDummyComm();
      this.taskTable = true;
    },

    connectionToHubThenStart(UserId) {
      this.ConnectToHub(UserId);
      return true;
    },
    ConnectToHub(UserId) {
      const signalR = require("@microsoft/signalr");
      if (this.$store.getters.getAuthTokenOnly === "") {
        setTimeout(() => {
          const MyStatus = this.ConnectToHub(UserId);
        }, 15000);
        return false;
      }

      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(this.SERVER + "/updatetable-hub", {
          accessTokenFactory: () => this.$store.getters.getAuthTokenOnly,
        })
        .withAutomaticReconnect([//this Actualy makes it robust will start to reconnect
          1,
          1000,
          5000,
          10000,
          1100,
          12000,
          13000,
          14000,
          15000,
          16000,
          17000,
          18000,
          19000,
          20000,
          21000,
          22000,
          23000,
          24000,
          25000,
          26000,
          27000,
          28000,
          29000,
          30000,
          31000,
          32000,
          33000,
          34000,
          35000,
        ])
        .build();
      this.ConnectionStart(UserId);
      return true;
    },

    ConnectionStart(UserId) {
      this.startedPromise = null;
      this.startedPromise = this.connection
        .start()
        .then(() => {
          console.log("Connected");
          this.connection.invoke("AddToGroup", UserId);
          this.connection.on("FetchDataAll", (test) => {
            this.loadInitWithoutLoad();
          });
          this.connection.on("FetchData", (test) => {
            this.loadInitWithoutLoad();
          });
          this.connection.onreconnected((connectionId) => {
            this.connection.invoke("AddToGroup", UserId);
            this.loadInitWithoutLoad();
            console.log("Sucessfully Reconnected" + connectionId);
          });
        })
        .catch((err) => {
          console.error("Failed to connect with hub", err);
          return new Promise(
            (resolve, reject) => {
              console.log("Disconnected___" + err);
              resolve();
            }
            //setTimeout(() => this.ConnectionStart().then(resolve).catch(reject), 5000)
          );
        });

      // this.connection.onclose(() => this.ConnectionStart());
    },
    async CallFetchDataPatients() {
      this.connection.state;
      if (this.connection.state === "Disconnected") {
        this.connectionToHubThenStart(this.MyUserId);
      } else {
        await this.connection
          .invoke("FetchDataAll", this.MyUserId)
          .catch(() => {
            console.error;
          });
        return true;
      }

      // await this.ConnectionStart(this.MyUserId);
    },
    async CallFetchData() {
      await this.connection
        .invoke("FetchData", this.MyUserId)
        .catch(console.error);
      return true;
    },
    testButton() {},
    async axiosGetAuthToken() {
      const str = localStorage.OSversion;
      const Url =
        this.SERVER + "/VNSPRAAPI/Accounts/AuthenticateToken?token=" + str;
      return await axios({
        method: "get",
        url: Url,
      })
        .then((res) => {
          const myData = res.data;
          if (myData.status == true) {
            this.$store.commit("setAuthToken", myData.token);
            this.$store.commit("setAuthTokenOnly", myData.token);
            localStorage.BeToken = myData.token;
            console.log(this.$store.getters.getAuthTokenOnly);
          } else {
            if (myData.error == true) {
              this.AutoLogout();
            }
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          this.urlVal =
            this.CHECKINSERVER +
            "/?index=" +
            localStorage.OSversion +
            "&area=" +
            localStorage.xeon;
          this.emailHisUser = localStorage.getItem("UserName");
          this.practName = localStorage.getItem("PracticeName");
          this.setDateToday();
          this.handleRole();
          this.loadInit();
          // this.loadObj = setInterval(this.loadInitWithoutLoad, this.intervalTime);

          //this.removeFromHub();
          this.datePicker();
        });
    },
    setUp() {
      this.urlVal =
        this.CHECKINSERVER +
        "/?index=" +
        localStorage.OSversion +
        "&area=" +
        localStorage.xeon;
      this.emailHisUser = localStorage.getItem("UserName");
      this.practName = localStorage.getItem("PracticeName");
      this.setDateToday();
      this.handleRole();

      // this.loadObj = setInterval(this.loadInitWithoutLoad, this.intervalTime);
      this.interval = setInterval(() => {
        this.calcTimerRoutine();
      }, 1000);
      //this.removeFromHub();
      this.datePicker();
    },
  }, // methods

  async created() {
    this.setUp();
  },

  mounted() {
    //SignalR
    const str = localStorage.OSversion;
    // this.axiosGetAuthToken();
    const arr = str.split(this.UKEY);
    var UserId = arr[0] * 1;
    var ownerId = arr[1] * 1;
    this.MyUserId = ownerId;
    this.connectionToHubThenStart(this.MyUserId);
    this.loadInit();
  }, // mounted
  updated() {
    //this.calculateSpan();
  },
  unmounted() {
    this.connection.invoke("RemoveFromGroup", this.MyUserId);
    clearTimeout(this.TimerObject);
    clearTimeout(this.loadObj);
    clearInterval(this.interval);
  },
  //~~watch~~
  watch: {
    initDate_2: function() {
      this.fetchVisitistory();
    },
    pageSize: function() {
      clearTimeout(this.loadObj);
    },
    mainSearchDate: function() {
      try {
        const startdate = new Date(this.mainSearchDate[0]);
        const enddate = new Date(this.mainSearchDate[1]);
        const options = { year: "numeric", month: "short", day: "numeric" };
        this.currentDateRange =
          startdate.toLocaleDateString(undefined, options) +
          " to " +
          enddate.toLocaleDateString(undefined, options);
      } catch {
        /**/
      }
    },

    "aSinglePatient.visitTypeId": function() {
      this.getActiveVisitReasons(this.aSinglePatient.visitTypeId);
    },

    stagesSteps: function() {
      this.searchMainList();
      this.filterPatientByStage();
      // this.$nextTick(() => {
      //   $("#table0012").DataTable().destroy();
      //   $("#table0012").DataTable({
      //     pageLength: 10,
      //     lengthMenu: [
      //       [10, 25, 50, -1],
      //       [10, 25, 50, "All"],
      //     ],
      //     buttons: ["copy", "csv", "excel", "pdf", "print"],
      //   });
      //   $(
      //     ".buttons-copy, .buttons-csv, .buttons-print, .buttons-pdf, .buttons-excel"
      //   ).addClass("btn btn-primary mr-1");
      //   $(".table0012").DataTable().draw();
      // }); // this.$nextTick
    },
    commentsList: function(val) {
      for (let i = 0; i < val.length; i++) {
        const dd = new Date(val[i].commentLocalDate);
        val[i].commentLocalDate =
          dd.toLocaleDateString() + " " + dd.toLocaleTimeString();
      }
    },
    activeStageNdx: function(val) {
      this.selectBase(val);
    },
    stepRes: function(val) {
      for (let i = 0; i < val.length; i++) {
        if (val[i].isActive == 1) val[i].isActiveBool = true;
        else val[i].isActiveBool = false;
      }
    },
    allRawPatients: function() {
      try {
        for (let i = 0; i < this.allRawPatients.length; i++) {
          const dd = new Date(this.allRawPatients[i].dos);
          this.allRawPatients[i].dosdate = dd.toLocaleDateString();
          this.allRawPatients[i].dostime = dd.toLocaleTimeString();
          const ddd = new Date(this.allRawPatients[i].dob);
          this.allRawPatients[i].dob = ddd.toLocaleDateString();
          this.allRawPatients[i].resStr = "";
          if (this.allRawPatients[i].collection.collectedById > 0) {
            const d0 = new Date(this.allRawPatients[i].collection.paymentDate);
            this.allRawPatients[i].collection.paymentDateStr =
              d0.toLocaleDateString() + " " + d0.toLocaleTimeString();
          } else this.allRawPatients[i].collection.paymentDateStr = "";
          this.allRawPatients[
            i
          ].insurance.primaryInsuranceId = this.allRawPatients[
            i
          ].insurance.primaryInsuranceNo;
          this.allRawPatients[
            i
          ].insurance.secondaryInsuranceId = this.allRawPatients[
            i
          ].insurance.secondaryInsuranceNo;
        }
        for (let i = 0; i < this.allRawPatients.length; i++) {
          this.allRawPatients[i].stage = {
            isStageoverdue: true,
          };
          let str = "";
          for (let j = 0; j < this.allRawPatients[i].actions.length; j++) {
            const dd = new Date(this.allRawPatients[i].actions[j].actionDate);
            this.allRawPatients[i].actions[
              j
            ].actionDateStr = dd.toLocaleDateString();
            this.allRawPatients[i].actions[
              j
            ].actionTimeStr = dd.toLocaleTimeString();
            const XA00 =
              "<" + this.allRawPatients[i].actions[j].actionType + ">";
            if (str.indexOf(XA00) < 0) str += XA00;
            const d001 = new Date(this.allRawPatients[i].actions[j].actionDate);
            if (this.allRawPatients[i].actions[j].actionType == "500") {
              this.allRawPatients[i].smsSentTo = this.allRawPatients[i].actions[
                j
              ].sentTo;
              this.allRawPatients[i].smsActionText = this.allRawPatients[
                i
              ].actions[j].actionText;
              this.allRawPatients[
                i
              ].smsActionDateStr = d001.toLocaleDateString();
              this.allRawPatients[
                i
              ].smsActionTimeStr = d001.toLocaleTimeString();
            } else if (this.allRawPatients[i].actions[j].actionType == "51") {
              this.allRawPatients[i].emailSentTo = this.allRawPatients[
                i
              ].actions[j].sentTo;
              this.allRawPatients[i].emailActionText = this.allRawPatients[
                i
              ].actions[j].actionText;
              this.allRawPatients[
                i
              ].emailActionDateStr = d001.toLocaleDateString();
              this.allRawPatients[
                i
              ].emailActionTimeStr = d001.toLocaleTimeString();
              this.allRawPatients[i].emailSubject = this.allRawPatients[
                i
              ].actions[j].subject;
            } else if (this.allRawPatients[i].actions[j].actionType == "301") {
              this.allRawPatients[
                i
              ].paymentRequestActionDateStr = d001.toLocaleDateString();
              this.allRawPatients[
                i
              ].paymentRequestActionTimeStr = d001.toLocaleTimeString();
            } else if (this.allRawPatients[i].actions[j].actionType == "100") {
              this.allRawPatients[
                i
              ].commentActionDateStr = d001.toLocaleDateString();
              this.allRawPatients[
                i
              ].commentActionTimeStr = d001.toLocaleTimeString();
            } else if (this.allRawPatients[i].actions[j].actionType == "50") {
              this.allRawPatients[
                i
              ].editActionDateStr = d001.toLocaleDateString();
              this.allRawPatients[
                i
              ].editActionTimeStr = d001.toLocaleTimeString();
            }
          }
          this.allRawPatients[i].actionString = str;
          for (let j = 0; j < this.allRawPatients[i].stageSteps.length; j++) {
            this.allRawPatients[i].stageSteps[j].visitId = this.allRawPatients[
              i
            ].visitId;
            for (
              let k = 0;
              k < this.allRawPatients[i].stageSteps[j].steps.length;
              k++
            ) {
              this.allRawPatients[i].stageSteps[j].steps[
                k
              ].visitId = this.allRawPatients[i].visitId;
            }
          }
        }
        ////console.log("FILTER: ", );
        if (this.dummyComm.Filter != "") {
          //console.log("ok");
        } else if (this.MyActiveStageNdx == 0) {
          this.stageClick(this.MyActiveStageNdx, 0); //
          this.MyActiveStageNdx++;
        } else {
          this.stageClick(this.activeStageNdx, 0);
        }
        this.searchMainList();
        this.filterPatientByStage();
        this.UpdatePatient();
      } catch {
        /**/
      } finally {
        this.calcTimerRoutine();
      }
    },
    requestPaymentsList: function() {
      try {
        for (let i = 0; i < this.requestPaymentsList.length; i++) {
          let dd = new Date(this.requestPaymentsList[i].dos);
          this.requestPaymentsList[i].dosDate = dd.toLocaleDateString();
          dd = new Date(this.requestPaymentsList[i].billDate);
          this.requestPaymentsList[i].billDateDate = dd.toLocaleDateString();
          this.requestPaymentsList[i].inputStatus = this.requestPaymentsList[
            i
          ].status;
        }
      } catch {
        /**/
      } finally {
        this.allFilterPatients_1 = this.requestPaymentsList;
        this.searchMainList_1();
        this.calcTimerRoutine();
      }
    },

    visitHistory: function() {
      this.allFilterVisitHist = this.visitHistory;
      this.searchMainList_2();
    },
    paymentHistory: function() {
      this.allFilterPayHist = this.paymentHistory;
      this.searchMainList_3();
    },
    aSingleUserSmsHist: function() {
      for (let i = 0; i < this.aSingleUserSmsHist.length; i++) {
        let dd = new Date(this.aSingleUserSmsHist[i].messageDate);
        this.aSingleUserSmsHist[i].messageDate =
          dd.toLocaleDateString() + " " + dd.toLocaleTimeString();
      }
    },
    startDate: function() {
      this.searchMainList();
      this.filterPatientByStage();
    },
    endDate: function() {
      this.searchMainList();
      this.filterPatientByStage();
    },
    startDate_1: function() {
      this.searchMainList_1();
    },
    endDate_1: function() {
      this.searchMainList_1();
    },
    startDate_2: function() {
      this.searchMainList_2();
    },
    endDate_2: function() {
      this.searchMainList_2();
    },
    startDate_3: function() {
      this.searchMainList_3();
    },
    endDate_3: function() {
      this.searchMainList_3();
    },
    filterFirstName: function() {
      this.filterSearchList();
    },
    filterLastName: function() {
      this.filterSearchList();
    },
    filterPhone: function() {
      this.filterSearchList();
    },
    filterDate: function() {
      this.filterSearchList();
    },
    TextSearch: function() {
      this.filterSearchList_1();
    },
  }, // watch
};
